import React, { useState, useEffect, useContext, useRef } from 'react'
import { useTranslation } from "react-i18next"
import './go.css'
import SimpleCreateBooking from '../../components/utils/simpleCreateBooking'
import { LoadingContext, LoadingBar, BufferService, NavigateContext, filtersSortService, M_FormFavorites, M_Fieldset  } from 'src/M_Components'
import { ExtensionForm } from 'src/components/genericEntity/entity/ExtensionForm'

export default function CreateBooking({ handleTabClose, toastMessages, roles, onCreateTab }) {
  const extensionFormRef = useRef()
  const ctx = useContext(LoadingContext)
  const ctx2 = useContext(NavigateContext)
  const [isLoaded, setIsLoaded] = useState(true)
  const [defaultBooking, setDefaultBooking] = useState(false)
  const [id, setId] = useState(sessionStorage.getItem('selectedTab'))
  const lineId = sessionStorage.getItem('bookingLine') !== null && sessionStorage.getItem('bookingLine') !== "undefined" ? JSON.parse(sessionStorage.getItem('bookingLine')).Id : null
  const [transportId, setTransportId] = useState(lineId)
  const { t } = useTranslation()
  const [voyageDict, setVoyageDict] = useState(new Map())
  const [entitiesDict, setEntitiesDict] = useState(new Map())
  const [locationsDict, setLocationsDict] = useState(new Map())
  const [equipmentDict, setEquipmentDict] = useState(new Map())
  const [bookingEquipmentDict, setBookingEquipmentDict] = useState(new Map())
  const [entitiesVarNameDict, setEntitiesVarNameDict] = useState(new Map())
  const [portsVarNameDict, setPortsVarNameDict] = useState(new Map())
  const [shipmentObjArray, setShipmentObjArray] = useState([])
  const [shipmentArray, setShipmentArray] = useState([])
  const [shipmentIndex, setShipmentIndex] = useState(1)
  const [linkedQuoteId, setLinkedQuoteId] = useState(null);
  const [bookingEquipmentArray, setBookingEquipmentArray] = useState([])
  const [shipmentChargesArray, setShipmentChargesArray] = useState([])
  const [pendingQuote, setPendingQuote] = useState(null)
  const [showChangeQuoteModal, setShowChangeQuoteModal] = useState(false)

  const isAdmin = (() => {
    try {
      const names = JSON.parse(sessionStorage.getItem('userRoleNames') || '[]')
      return names.some(n => n === 'Admin' || n === 'SuperAdmin')
    } catch { return false }
  })()

  const [formVoyage, setFormVoyage] = useState(true)
  const [formEntities, setFormEntities] = useState(false)
  const [formPortsLocations, setFormPortsLocations] = useState(false)
  const [formEquipments, setFormEquipments] = useState(false)
  const [openConfirmModal, setOpenConfirmModal] = useState(false)

  const [confirmationModal, setConfirmationModal] = useState(false)
  const [containerIndex, setContainerIndex] = useState(1)
  const [EquipmentIndex, setEquipmentIndex] = useState(1)
  const [equipmentTypes, setEquipmentTypes] = useState([])
  const [extraValues, setExtraValues] = useState(new Map())
  const [openDrawer, setOpenDrawer] = useState(false)
  const [selectedLine, setSelectedLine] = useState(null)
  const [ifFirstLoop, setIsFirstLoop] = useState(true)

  const passOperation = sessionStorage.getItem('operation') !== null ? sessionStorage.getItem('operation') : 'Error'
  const [operation, setOperation] = useState(passOperation)
  const [bookingLine, setBookingLine] = useState(null)

  const [equipmentClass, setEquipmentClass] = useState([])
  const [waitingApproval, setWaitingApproval] = useState('')
  const [pendingEquipments, setPendingEquipments] = useState([])
  const [draft, setDraft] = useState('')
  const [approved, setApproved] = useState('')
  const [saveAs, setSaveAs] = useState('Waiting')
  const [listErrors, setListErrors] = useState('')

  const [changedList, setChangedList] = useState([])

  const [drawerName, setDrawerName] = useState('')

  const [companies, setCompanies] = useState([])

  const [leavingPage, setLeavingPage] = useState(false)

  const [isClient, setIsClient] = useState(false)

  const [openEquipmentDrawer, setOpenEquipmentDrawer] = useState(false)
  const [confirmMovement, setConfirmMovement] = useState(false)
  const [open, setOpen] = useState(false)
  const [FILTERVGM, setFILTERVGM] = useState('')
  let isMove = false

  const shipmentBuffer = new BufferService('shipment')
  const shipmentChargesService = new BufferService('ShipmentCharges')
  const shipmentDetailsBuffer = new BufferService('shipmentDetail')
  const filterService = new filtersSortService()
  const bookingEquipmentService = new BufferService('bookingEquipment/move')

  const bookingV2Service = new BufferService('viewbooking')
  const processStatusService = new BufferService('processStatus')
  const transportService = new BufferService('transport')
  const accountService = new BufferService('account')
  const auditService = new BufferService('audit/lastbooking')
  const errorList = new BufferService('viewbookingerrors')
  var quoteGetService = new BufferService("quotegetrequest")
  const locationService = new BufferService('location')

  const containerEquipmentService = new BufferService('Equipment', 'secondary')
  const containerEquipmentTypeService = new BufferService('EquipmentType', 'secondary')

  const valueTimeline = [
    { icon: `pi ${!extraValues.get('CreatedOn') ? 'pi-spin pi-spinner' : 'pi-circle-fill'}`, name: t("TimeLineCreatBook"), color: 'white', connectorColor: 'var(--color-blue)', date: extraValues.get('CreatedOn') ? reformatDate(toJSONLocalBE(extraValues.get('CreatedOn'))) : '' },
    { icon: `pi ${extraValues.get('CreatedOn') && !extraValues.get('DateApproved') ? 'pi-spin pi-spinner' : extraValues.get('DateApproved') ? 'pi-circle-fill' : 'pi-circle'}`, name: t("TimeLineBookAccp"), color: 'white', connectorColor: 'var(--color-blue)', date: extraValues.get('DateApproved') || '' },
    { icon: `pi ${extraValues.get('DateApproved') ? 'pi-spin pi-spinner' : 'pi-circle'}`, name: t("TimeLineInsCont"), color: 'white)', connectorColor: 'var(--color-blue)', date: '' },
    { icon: 'pi pi-circle', name: t("TimeLineCreBL"), color: 'white', connectorColor: 'var(--color-blue)', date: '' },
    { icon: 'pi pi-circle', name: t("TimeLineBLAccep"), color: 'White', connectorColor: 'var(--color-blue-light)', date: '' }
  ]
  const voyage = [
    { label: 'Vessel', tablecode: 'name', code: 'VesselCode', id: 'TransportId' },
    { label: 'Voyage', tablecode: 'voyageNumber', code: 'VoyageNumber', id: 'TransportId' },
  ]
  const entities = [
    { label: 'Client', tablecode: 'accountCode', code: 'ClientCode', id: 'ClientId' },
    { label: 'Client VAT', tablecode: 'accountVATNumber', code: 'ClientVAT', id: 'ClientId' },
    { label: 'Client Reference', tablecode: 'clientReference', code: 'ClientReference' },
    { label: 'Invoice Entity', tablecode: '', code: 'InvoiceCode', id: 'InvoiceId' },
    { label: 'Invoice VAT', tablecode: '', code: 'InvoiceVat', id: 'InvoiceId' },
  ]
  const portsLocations = [
    { label: 'Original Port', tablecode: 'Name', type: 'textfield', code: 'OriginalPortName', name: 'LocationReceiptPortName', id: 'LocationReceiptId', show: true },
    { label: 'Loading Port', tablecode: 'Name', type: 'textfield', code: 'LoadingPortName', name: 'LocationLoadingPortName', id: 'LoadingPortId', show: true },
    { label: 'Discharge Port', tablecode: 'Name', type: 'textfield', code: 'DischargePortName', name: 'LocationDischargePortName', id: 'DischargePortId', show: true },
    { label: 'Final Port', tablecode: 'Name', type: 'textfield', code: 'FinalPortName', name: 'LocationDeliveryPortName', id: 'LocationDeliveryPortId', show: true },
    { label: 'Original Port Code', tablecode: 'Name', type: 'textfield', code: 'OriginalPortCode', name: 'OriginalPortCode', id: 'LocationReceiptId', show: false, },
    { label: 'Loading Port Code', tablecode: 'Name', type: 'textfield', code: 'LoadingPortCode', name: 'LoadingPortCode', id: 'LoadingPortId', show: false, },
    { label: 'Discharge Port Code', tablecode: 'Name', type: 'textfield', code: 'DischargePortCode', name: 'DischargePortCode', id: 'DischargePortId', show: false, },
    { label: 'Final Port Code', tablecode: 'Name', type: 'textfield', code: 'FinalPortCode', name: 'FinalPortCode', id: 'LocationDeliveryPortId', show: false, },
    { label: 'Transhipment', tablecode: '', type: 'checkbox', code: 'Transhipment', name: 'Transhipment', show: true, },
  ]
  const equipments = [
    { label: 'Quantity', tablecode: '', type: 'textfield', code: '' },
    { label: 'Equipment Type', tablecode: '', type: 'combobox', code: '' },
    { label: 'Cargo Description', tablecode: '', type: 'textfield', code: 'GoodsDetails' },
    { label: 'Load Weight (KG)', tablecode: '', type: 'textfield', code: 'TransportDetails' },
    { label: 'Loading Date', tablecode: '', type: 'date', code: 'LoadingDate' },
    { label: 'Shipment', tablecode: '', type: 'combobox', code: '' },
    { label: 'SOC', tablecode: '', type: 'checkbox', code: 'SOC' },
    { label: 'IMO', tablecode: '', type: 'checkbox', code: 'IMO' },
    { label: 'Reefer', tablecode: '', type: 'checkbox', code: 'Reefer' },
    { label: 'Open Top/FLAT', tablecode: '', type: 'checkbox', code: 'OpenTop' },
    { label: 'RORO', tablecode: '', type: 'checkbox', code: 'RORO' },
  ]
  const bookingEquipments = [
      { label: 'Shipment', type: 'combobox', code: 'Shipment' },
      { label: 'Equipment', type: 'foreignKeyEquipment', code: 'Equipment', entity: 'Equipment', api: 'secondary', filterField: 'Code', labelFields: ['Code', 'Length'] },
      { label: 'Park Code', type: 'foreignKey', code: 'ParkCode', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationCode'] },
      { label: 'Terminal Loading Code', type: 'foreignKey', code: 'TerminalLoadLocation', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationCode'] },
      { label: 'Terminal Discharge Code', type: 'foreignKey', code: 'TerminalDischargeLocation', entity: 'Location', filterField: 'LocationName', labelFields: ['LocationCode'] },
      { label: 'Booking Date', type: 'date', code: 'BookingDate' },
      { label: 'Gate Date', type: 'date', code: 'GateDate' },
  ]
  const extraValuesArray = [
    { label: 'CreatedOn', create: 'CreatedOn', edit: 'CreatedOn' },
    { label: 'DateApproved', create: 'DateApproved', edit: 'DateApproved' },

    { label: 'transport id', create: 'TransportId', edit: 'TransportId' },
    { label: 'Original Port id', create: 'LocationReceiptId', edit: 'LocationReceiptId' },
    { label: 'Loading Port id', create: 'LoadingPortId', edit: 'LoadingPortId' },
    { label: 'Discharge Port id', create: 'DischargePortId', edit: 'DischargePortId' },
    { label: 'Final Port id', create: 'LocationDeliveryPortId', edit: 'LocationDeliveryPortId' },
    { label: 'Client Id', create: 'ClientId', edit: 'ClientId' },
    { label: 'Waiting for Approval id', create: 'ProcessStatusId', edit: 'ProcessStatusId' },
    { label: 'BookingNumber', create: 'BookingNumber', edit: 'BookingNumber' },
    { label: 'UserCompanyId', create: 'UserCompanyId', edit: 'UserCompanyId' },
    { label: 'InvoiceId', create: 'InvoiceId', edit: 'InvoiceId' }
  ]

  const fieldsInDrawerEquipment = ['temp', 'Prefix', 'Number', 'CheckDigit', 'Payload', 'Tare', 'onOff', 'DimensionsWidth', 'DimensionsHeight', 'DimensionsLength', 'Front', 'Back', 'Right', 'Left', 'Height', 'Brand', 'Model', 'Chassis',]
  const fieldsInDrawerShipment = ['IdCommodity', 'CommodityCode', 'CommodityName', 'IdDangerousGoods', 'FlashPT', 'PackagingGroup']

  const addValue = (key, value, dict, setDict) => {

    if (key === 'Original Port') {
      if (value !== "") {
        dict.set("Transhipment", true)
      } else {
        dict.set("Transhipment", false)
      }
    }

    if (key === 'Equipment Type') {
      value = value.trim()
      if (value.search('RF') !== -1 || value.search('HR') !== -1) {
        dict.set("Reefer", true)
        dict.set("RORO", false)
        dict.set("OpenTop", false)
      }
      else {
        dict.set("Reefer", false)
        if (value.search('OT') !== -1 || value.search('FL') !== -1) {
          dict.set("RORO", false)
          dict.set("OpenTop", true)
        }
        else {
          dict.set("OpenTop", false)
          if (value.search('RORO') !== -1) {
            dict.set("RORO", true)
          }
          else {
            dict.set("RORO", false)
          }
        }
      }
    }
    if (typeof value === 'string' || value instanceof String) {
      value = value.toLocaleUpperCase()
    }

    dict.set(key, value)
    setDict(new Map(dict))
  }

  const sessionKeys = ['transportId', 'defaultBooking', 'voyageDict',
    'entitiesDict', 'locationsDict', 'equipmentDict', 'shipmentObjArray',
    'shipmentArray', 'shipmentIndex', 'containerIndex', 'equipmentTypes',
    'extraValues', 'formVoyage', 'formEntities', 'formPortsLocations',
    'formEquipments', 'operation', 'waitingApproval', 'companies',
    'changedList', 'equipmentClass', 'EquipmentIndex', 'bookingLine', 'listErrors',
    'shipmentChargesArray']

  useEffect(() => {
    if (ifFirstLoop) {
      ctx.setIsLoad(true)
      console.log(sessionStorage.getItem('operation'))
      sessionStorage.removeItem('operation')
      getSessionStorageData(id)
      setIsFirstLoop(false)
      sessionStorage.setItem(`tab${id}`, JSON.stringify(sessionKeys))
    }
  }, [])

  useEffect(() => {
    const newId = sessionStorage.getItem('selectedTab')
    if (newId !== id) {
      setId(newId)
      getSessionStorageData(newId)
    }
    if (sessionStorage.getItem('chargesNeedRefresh') === '1') {
      sessionStorage.removeItem('chargesNeedRefresh')
      setChargesRefreshTick(t => t + 1)
    }
  })
  
  const [chargesRefreshTick, setChargesRefreshTick] = useState(0)

  const refreshShipmentCharges = () => setChargesRefreshTick(t => t + 1)

  const chargesBookingNumber = extraValues.get('BookingNumber') || ''

  useEffect(() => {
    if (chargesBookingNumber) {
      shipmentChargesService.filter(`/queryByBooking?booking_number=${chargesBookingNumber}`)
        .then(data => {
          if (data && !data.name) {
            setShipmentChargesArray(Array.isArray(data) ? data : (data?.value || []))
          }
        })
    } else {
      setShipmentChargesArray([])
    }
  }, [chargesBookingNumber, chargesRefreshTick])

  const moveEquipment = () => {
      setOpenEquipmentDrawer(true)
  }
 
  useEffect(() => {
    sessionKeys.forEach((key) => {
      sessionStorageMachine(id, key, key)
    })
  }, [id, transportId, defaultBooking, voyageDict, entitiesDict,
    locationsDict, equipmentDict, shipmentObjArray, shipmentArray,
    shipmentIndex, containerIndex, equipmentTypes, extraValues,
    formVoyage, formEntities, formPortsLocations, formEquipments,
    operation, waitingApproval, companies, changedList,
    equipmentClass, EquipmentIndex, bookingLine, listErrors])

  const sessionStorageMachine = (id, key, value) => {
    if (eval(value) instanceof Map) {
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(Array.from(eval(value))))
    } else {
      sessionStorage.setItem(`${id}${key}`, JSON.stringify(eval(value)))
    }
  }

  useEffect(() => {
    const combined = new Map()
    
    // Do entitiesDict
    combined.set('Company', entitiesDict.get('Company') || '')
    combined.set('ClientCode', entitiesDict.get('ClientCode') || '')
    combined.set('ClientVAT', entitiesDict.get('ClientVAT') || '')
    combined.set('ClientReference', entitiesDict.get('ClientReference') || '')
    combined.set('InvoiceCode', entitiesDict.get('InvoiceCode') || '')
    combined.set('InvoiceVat', entitiesDict.get('InvoiceVat') || '')
    
    // IDs do extraValues
    combined.set('UserCompanyId', extraValues.get('UserCompanyId') || '')
    combined.set('Client Id', extraValues.get('Client Id') || '')
    combined.set('InvoiceId', extraValues.get('InvoiceId') || '')
    
    setEntitiesVarNameDict(new Map(combined))
  }, [entitiesDict, extraValues])

  useEffect(() => {
    const combined = new Map()
    
    // Do locationsDict
    combined.set('Original Port', locationsDict.get('Original Port') || '')
    combined.set('Loading Port', locationsDict.get('Loading Port') || '')
    combined.set('Discharge Port', locationsDict.get('Discharge Port') || '')
    combined.set('Final Port', locationsDict.get('Final Port') || '')
    combined.set('Transhipment', locationsDict.get('Transhipment') || false)
    
    // IDs do extraValues
    combined.set('Original Port id', extraValues.get('Original Port id') || '')
    combined.set('Loading Port id', extraValues.get('Loading Port id') || '')
    combined.set('Discharge Port id', extraValues.get('Discharge Port id') || '')
    combined.set('Final Port id', extraValues.get('Final Port id') || '')
    
    setPortsVarNameDict(new Map(combined))
  }, [locationsDict, extraValues])

  // Handlers para quando favorito é aplicado
  const handleEntitiesFavoriteApply = (newMap) => {
    // Atualizar entitiesDict
    const newEntitiesDict = new Map(entitiesDict)
    newEntitiesDict.set('Company', newMap.get('Company') || '')
    newEntitiesDict.set('ClientCode', newMap.get('ClientCode') || '')
    newEntitiesDict.set('ClientVAT', newMap.get('ClientVAT') || '')
    newEntitiesDict.set('ClientReference', newMap.get('ClientReference') || '')
    newEntitiesDict.set('InvoiceCode', newMap.get('InvoiceCode') || '')
    newEntitiesDict.set('InvoiceVat', newMap.get('InvoiceVat') || '')
    setEntitiesDict(newEntitiesDict)

    // Atualizar extraValues com IDs
    const newExtraValues = new Map(extraValues)
    newExtraValues.set('UserCompanyId', newMap.get('UserCompanyId') || '')
    newExtraValues.set('Client Id', newMap.get('Client Id') || '')
    newExtraValues.set('InvoiceId', newMap.get('InvoiceId') || '')
    setExtraValues(newExtraValues)

    // Se tem UserCompanyId mas NÃO tem Client Id (guardou só a Company como field),
    // buscar o accountId e chamar getAccountCompany para preencher o Client automaticamente
    const userCompanyId = newMap.get('UserCompanyId')
    const clientId = newMap.get('Client Id')

    if (userCompanyId && !clientId && companies?.length > 0) {
      const company = companies.find(c => c.Id === userCompanyId)
      if (company?.AccountId) {
        getAccountCompany(company.AccountId)
      }
    }

    setEntitiesVarNameDict(new Map(newMap))
  }

  const handlePortsFavoriteApply = (newMap) => {
    // Atualizar locationsDict
    const newLocationsDict = new Map(locationsDict)
    newLocationsDict.set('Original Port', newMap.get('Original Port') || '')
    newLocationsDict.set('Loading Port', newMap.get('Loading Port') || '')
    newLocationsDict.set('Discharge Port', newMap.get('Discharge Port') || '')
    newLocationsDict.set('Final Port', newMap.get('Final Port') || '')
    newLocationsDict.set('Transhipment', newMap.get('Transhipment') || false)
    setLocationsDict(newLocationsDict)
    
    // Atualizar extraValues com IDs
    const newExtraValues = new Map(extraValues)
    newExtraValues.set('Original Port id', newMap.get('Original Port id') || '')
    newExtraValues.set('Loading Port id', newMap.get('Loading Port id') || '')
    newExtraValues.set('Discharge Port id', newMap.get('Discharge Port id') || '')
    newExtraValues.set('Final Port id', newMap.get('Final Port id') || '')
    setExtraValues(newExtraValues)
    
    setPortsVarNameDict(new Map(newMap))
  }

  const getSessionStorageData = (sessionID) => {
    const tempDB = JSON.parse(sessionStorage.getItem(`${sessionID}defaultBooking`))
    const tempBI = JSON.parse(sessionStorage.getItem(`${sessionID}transportId`))
    const tempVD = JSON.parse(sessionStorage.getItem(`${sessionID}voyageDict`))
    const tempED = JSON.parse(sessionStorage.getItem(`${sessionID}entitiesDict`))
    const tempLD = JSON.parse(sessionStorage.getItem(`${sessionID}locationsDict`))
    const tempEQD = JSON.parse(sessionStorage.getItem(`${sessionID}equipmentDict`))
    const tempSOA = JSON.parse(sessionStorage.getItem(`${sessionID}shipmentObjArray`))
    const tempSA = JSON.parse(sessionStorage.getItem(`${sessionID}shipmentArray`))
    const tempSI = JSON.parse(sessionStorage.getItem(`${sessionID}shipmentIndex`))
    const tempCI = JSON.parse(sessionStorage.getItem(`${sessionID}containerIndex`))
    const tempET = JSON.parse(sessionStorage.getItem(`${sessionID}equipmentTypes`))
    const tempEV = JSON.parse(sessionStorage.getItem(`${sessionID}extraValues`))
    const tempFV = JSON.parse(sessionStorage.getItem(`${sessionID}formVoyage`))
    const tempFE = JSON.parse(sessionStorage.getItem(`${sessionID}formEntities`))
    const tempFPL = JSON.parse(sessionStorage.getItem(`${sessionID}formPortsLocations`))
    const tempFEQ = JSON.parse(sessionStorage.getItem(`${sessionID}formEquipments`))
    const tempO = JSON.parse(sessionStorage.getItem(`${sessionID}operation`))
    const tempWA = JSON.parse(sessionStorage.getItem(`${sessionID}waitingApproval`))
    const tempC = JSON.parse(sessionStorage.getItem(`${sessionID}companies`))
    const tempCL = JSON.parse(sessionStorage.getItem(`${sessionID}changedList`))
    const tempEC = JSON.parse(sessionStorage.getItem(`${sessionID}equipmentClass`))
    const tempEI = JSON.parse(sessionStorage.getItem(`${sessionID}EquipmentIndex`))
    const tempBL = JSON.parse(sessionStorage.getItem(`${sessionID}bookingLine`))
    const tempLE = JSON.parse(sessionStorage.getItem(`${sessionID}listErrors`))
    const tempSCA = JSON.parse(sessionStorage.getItem(`${sessionID}shipmentChargesArray`))
    if (tempDB || tempBI || tempVD || tempED || tempLD || tempEQD || tempSOA || tempSA || tempSI || tempCI || tempET || tempEV || tempFV || tempFE || tempFPL || tempFEQ || tempO || tempWA || tempC || tempCL || tempEC || tempEI || tempBL || tempLE) {
      setTransportId(tempBI)
      setDefaultBooking(tempDB)
      setVoyageDict(new Map(tempVD))
      setEntitiesDict(new Map(tempED))
      setLocationsDict(new Map(tempLD))
      setEquipmentDict(new Map(tempEQD))
      setShipmentObjArray(tempSOA)
      setShipmentArray(tempSA)
      setShipmentIndex(tempSI)
      setContainerIndex(tempCI)
      setEquipmentTypes(tempET)
      setExtraValues(new Map(tempEV))
      setFormVoyage(tempFV)
      setFormEntities(tempFE)
      setFormPortsLocations(tempFPL)
      setFormEquipments(tempFEQ)
      setOperation(tempO)
      setWaitingApproval(tempWA)
      setCompanies(tempC)
      setChangedList(tempCL)
      setEquipmentClass(tempEC)
      setEquipmentIndex(tempEI)
      setBookingLine(tempBL)
      setListErrors(tempLE)
      if (tempSCA) setShipmentChargesArray(tempSCA)
      setIsLoaded(false)
      ctx.setIsLoad(false)
      return
    }
    get()
    // options()
  }

  const get = () => {
    let approved = ''
    let reject = ''
    processStatusService.get().then(dataProcessStatusService => {
      if (dataProcessStatusService.name === 'AxiosError') {
        toastMessages('error', dataProcessStatusService.message, '')
        return
      }
      dataProcessStatusService.Items.forEach(data => {
        if (data.StatusName === 'Waiting for Approval') {
          setWaitingApproval(data.Id)
          setExtraValues(new Map(extraValues))
        }
        if (data.StatusName === 'Draft') {
          setDraft(data.Id)
          setExtraValues(new Map(extraValues))
        }
        if (data.StatusName === 'Approved') {
          approved = data.Id
          setApproved(approved)
        }
        if (data.StatusName === 'Rejected') {
          reject = data.Id
          setApproved(reject)
        }
      })

      equipments.forEach(elem => {
        if (elem.type === 'checkbox') {
          addValue(elem.code, false, equipmentDict, setEquipmentDict)
        } else {
          addValue(elem.label, '', equipmentDict, setEquipmentDict)
        }
      })
      addValue('Shipment', "", equipmentDict, setEquipmentDict)

      if (operation === 'Create') {
        const rawBookingLine = sessionStorage.getItem('bookingLine')
        const bookingLineData = rawBookingLine && rawBookingLine !== 'null' && rawBookingLine !== 'undefined'
          ? JSON.parse(rawBookingLine)
          : null
        sessionStorage.removeItem('bookingLine')
        if (!bookingLineData) {
          toastMessages('error', 'Booking line data not found. Please select a voyage and try again.', '')
          ctx.setIsLoad(false)
          return
        }
        addValue('Voyage', bookingLineData.VoyageNumber, voyageDict, setVoyageDict)
        addValue('Vessel', bookingLineData.VesselCode, voyageDict, setVoyageDict)
        extraValues.set('transport id', transportId)
        setExtraValues(new Map(extraValues))

        let tempCompanies = JSON.parse(sessionStorage.getItem('companies'))
        if (tempCompanies.length == 1) {
          if (tempCompanies[0].AccountId === null || tempCompanies[0].AccountId === undefined) {
            toastMessages('error', ' An unexpected error ocurred. Pleased logout, login and try again. ', '')
            tempCompanies = []
          } else {
            accountService.getId(tempCompanies[0].AccountId).then(responseAccount => {
              if (responseAccount.name === 'AxiosError') {
                toastMessages('error', responseAccount.message, '')
              }
              addValue('UserCompanyId', tempCompanies[0].Id, extraValues, setExtraValues)
              addValue('ClientCode', responseAccount.AccountCode, entitiesDict, setEntitiesDict)
              addValue('ClientVAT', responseAccount.AccountVATNumber, entitiesDict, setEntitiesDict)
              addValue('Client Id', responseAccount.Id, extraValues, setExtraValues)
            })
          }
        }

        setCompanies(tempCompanies)
        ctx.setIsLoad(false)
        setIsLoaded(false)
      } else {
        if (operation === 'Edit' || operation === 'Copy') {
          bookingV2Service.getId(transportId).then(data => {
            if (data.name === 'AxiosError') {
              toastMessages('error', '', data.message)
              handleTabClose(JSON.parse(id))
              ctx.setIsLoad(false)
              return
            }

            extraValues.set("QuoteName", data.Booking.QuoteName)
            if(data.Booking.QuoteId !== null || data.Booking.QuoteId !== undefined) {
              setLinkedQuoteId(data.Booking.QuoteId)
            }

            data.ShipmentPlusList = data.ShipmentPlusList.sort((a, b) => a.Shipment.Order === b.Shipment.Order ? a.Shipment.TransportKey - b.Shipment.TransportKey : a.Shipment.Order - b.Shipment.Order)

            errorList.getId(transportId).then(dataErrorList => {
              if (dataErrorList.name === 'AxiosError') {
                toastMessages('error', dataErrorList.message, '')
                handleTabClose(JSON.parse(id))
                ctx.setIsLoad(false)
                return
              }
              setListErrors(dataErrorList)
            })

            auditService.getId(transportId).then(audit => {
              const tempMap = new Map(Object.entries(audit)) || new Map()
              tempMap.set('0', [])

              const dataBooking = data?.Booking
              setBookingLine(dataBooking)

              if (dataBooking.VoyageStatus !== 'Closed') {
                voyage.forEach(obj => {
                  addValue(obj.label, dataBooking[obj.code], voyageDict, setVoyageDict)
                })
              } else {

              }

              entities.forEach(obj => {
                addValue(obj.code, dataBooking[obj.code], entitiesDict, setEntitiesDict)
              })



              let tempCompanies = JSON.parse(sessionStorage.getItem('companies'))
              if (tempCompanies.length == 1) {
                if (tempCompanies[0].AccountId === null || tempCompanies[0].AccountId === undefined) {
                  tempCompanies = []
                }
              }
              setCompanies(tempCompanies)

              tempCompanies.forEach(obj => {
                if (obj.Id === dataBooking.UserCompanyId) {
                  addValue('Company', obj.Code, entitiesDict, setEntitiesDict)
                  addValue('UserCompanyId', obj.Id, extraValues, setExtraValues)
                }
              })

              portsLocations.forEach(obj => {
                if (obj.type === 'checkbox' && !(dataBooking[obj.code] === true || dataBooking[obj.code] === false)) {
                  if (dataBooking[obj.name] === 'Y' || dataBooking[obj.name] === 'S') {
                    addValue(obj.label, true, locationsDict, setLocationsDict)
                  } else {
                    addValue(obj.label, false, locationsDict, setLocationsDict)
                  }
                } else {
                  addValue(obj.label, dataBooking[obj.name], locationsDict, setLocationsDict)
                }
              })

              extraValuesArray.forEach(obj => {
                if (obj.edit === 'TransportId') {
                  if (dataBooking.VoyageStatus !== 'Closed') {
                    addValue(obj.label, dataBooking[obj.edit], extraValues, setExtraValues)
                  }
                } else {
                  if (obj.edit === 'CreatedOn' || obj.edit === 'DateApproved' || obj.edit === 'BookingNumber') {
                    if (operation === 'Edit') {
                      addValue(obj.label, dataBooking[obj.edit], extraValues, setExtraValues)
                    }
                  } else {
                    addValue(obj.label, dataBooking[obj.edit], extraValues, setExtraValues)
                  }
                }
              })
              if (!dataBooking.UserCompanyId) {
                addValue('UserCompanyId', tempCompanies[0].Id, extraValues, setExtraValues)
              }

              addValue('id', transportId, extraValues, setExtraValues)
              let tempArrayObj = []
              let tempShipmentArray = []

              let mainIndex = 0
              let tempEquipmentIndex = EquipmentIndex
              let tempEquipmentClass = []
              let tempEquipmentIndexes = new Map()
              data.ShipmentPlusList.forEach((shipments, shipIndex) => {
                shipments.ShipmentDetailPlusList.forEach((shipmentsDetails, index) => {

                  const bookingEquipment = shipmentsDetails.BookingEquipment
                  const isBookingEquipment = bookingEquipment && 
                      (bookingEquipment.IdParkLocation || 
                      bookingEquipment.IdTerminalLoadLocation || 
                      bookingEquipment.IdTerminalDischargeLocation ||
                      bookingEquipment.BookingDate ||
                      bookingEquipment.GateDate)

                  if (isBookingEquipment) {
                      return
                  }

                  // debugger
                  tempEquipmentIndex++
                  let tempToUseEquipmentIndex = tempEquipmentIndex
                  let tempEquipment = 'yes'

                  if (!tempEquipmentIndexes.get(shipmentsDetails.BookingEquipment.Id)) {
                    tempEquipmentIndexes.set(shipmentsDetails.BookingEquipment.Id, tempToUseEquipmentIndex)
                  } else {
                    tempToUseEquipmentIndex = tempEquipmentIndexes.get(shipmentsDetails.BookingEquipment.Id)
                    tempEquipment = 'no'
                  }

                  mainIndex++
                  const equipmentClassCode = shipmentsDetails.EquipmentClass?.EquipmentCode || shipmentsDetails.EquipmentType?.EquipmentTypeCode || '';
                  if (equipmentClassCode)
                      tempEquipmentClass.push(equipmentClassCode)

                  let tempObj = {
                    'id': mainIndex,
                    'Quantity': '1',
                    'shipOrder': shipments.Shipment.Order,
                    'shipTransOrder': shipments.Shipment.TransportKey,
                    'ShipmentId': operation === 'Edit' && shipments.Shipment.Id || null,
                    'ShipmentDetailsId': operation === 'Edit' && shipmentsDetails.ShipmentDetail.Id || null,
                    'bookingEquipmentId': operation === 'Edit' && shipmentsDetails.BookingEquipment.Id || null,
                    'EquipmentTransportKey': shipmentsDetails.BookingEquipment.TransportKey,
                    'IsFromTransporter': shipmentsDetails.BookingEquipment.IsFromTransporter,
                    'EquipmentIndex': tempToUseEquipmentIndex,
                    'EquipmentTypeId': shipmentsDetails.EquipmentType?.Id || shipmentsDetails.BookingEquipment?.ContainerControlEquipmentTypeId || shipmentsDetails.BookingEquipment?.IdEquipmentType || '',                    
                    'Equipment Type': `${shipmentsDetails.EquipmentType?.EquipmentTypeLenght || ''}${shipmentsDetails.EquipmentType?.EquipmentTypeCode || ''}`,

                    'NrPackage': shipmentsDetails.ShipmentDetail?.Package,
                    'Description': shipmentsDetails.ShipmentDetail?.Description,
                    'Weight': shipmentsDetails.ShipmentDetail?.Weight,
                    'Measurements': shipmentsDetails.ShipmentDetail?.Measures,

                    'Cargo Description': shipmentsDetails.BookingEquipment.GoodsDetails ? shipmentsDetails.BookingEquipment.GoodsDetails : '',
                    'Load Weight (KG)': shipmentsDetails.BookingEquipment.TransportDetails ? shipmentsDetails.BookingEquipment.TransportDetails : '',
                    'Loading Date': shipmentsDetails?.BookingEquipment?.LoadingDate ? shipmentsDetails?.BookingEquipment?.LoadingDate.slice(0, shipmentsDetails?.BookingEquipment?.LoadingDate?.search('T') || '') : '',
                    'Shipment': shipments.Shipment.TransportKey,
                    'SOC': shipmentsDetails.BookingEquipment.SOC === 'Y' ? true : false,
                    'IMO': shipments.Shipment.IMODangerGoods ? shipments.Shipment.IMODangerGoods : false,
                    'Reefer': shipmentsDetails.EquipmentType?.EquipmentTypeCode?.includes('RF') || shipmentsDetails.EquipmentType?.EquipmentTypeCode?.includes('HR') ? true : false,
                    'onOff': shipments.Shipment.Temp !== 0 && shipments.Shipment.Temp !== undefined && shipments.Shipment.Temp !== null ? true : false,
                    'temp': shipments.Shipment.Temp === 0 ? '' : shipments.Shipment.Temp,
                    'Brand': shipmentsDetails.BookingEquipment.Brand,
                    'Model': shipmentsDetails.BookingEquipment.Model,
                    'Chassis': shipmentsDetails.BookingEquipment.Chassis,
                    'RORO': shipmentsDetails.EquipmentType?.EquipmentTypeCode?.includes('RORO') || false,
                    'OpenTop': shipmentsDetails.EquipmentType?.EquipmentTypeCode?.includes('OT') || shipmentsDetails.EquipmentType?.EquipmentTypeCode?.includes('FL') ? true : false,
                    'EquipmentId': operation === 'Edit' && shipmentsDetails?.Equipment?.Id || '00000000-0000-0000-0000-000000000000',
                    'EquipmentClassCode': shipmentsDetails?.EquipmentClass?.EquipmentCode,
                    'Prefix': operation === 'Edit' && shipmentsDetails?.Equipment?.Prefix || '',
                    'Number': operation === 'Edit' && shipmentsDetails?.Equipment?.Number || '',
                    'CheckDigit': operation === 'Edit' && shipmentsDetails?.Equipment?.CheckDigit || '',
                    'Tare': operation === 'Edit' && shipmentsDetails?.Equipment?.Tare || shipmentsDetails.EquipmentType?.EquipmentTypeTareWeight || '',
                    'Payload': operation === 'Edit' && shipmentsDetails?.Equipment?.Payload || '',
                    'equipmentNumber': operation === 'Edit' && `${shipmentsDetails?.Equipment?.Prefix} ${shipmentsDetails?.Equipment?.Number} ${shipmentsDetails?.Equipment?.CheckDigit}` || '',
                    'DimensionsId': shipmentsDetails.BookingEquipmentDimensionsList[0]?.Id,
                    'DimensionsWidth': shipmentsDetails?.BookingEquipmentDimensionsList[0]?.DimensionsWidth,
                    'DimensionsHeight': shipmentsDetails?.BookingEquipmentDimensionsList[0]?.DimensionsHeight,
                    'DimensionsLength': shipmentsDetails?.BookingEquipmentDimensionsList[0]?.DimensionsLength,
                    'CommodityId': shipments.Shipment?.IdCommodity,
                    'CommodityCode': shipments.Shipment?.CommodityCode,
                    'CommodityName': shipments.Shipment?.CommodityName,
                    'Equipment': operation === 'Edit' && tempEquipment || null,
                    'shipmentChanged': operation === 'Edit' && [...deRetardLabels(tempMap.get(shipments.Shipment.Id || '0') || [], 'Shipment'), ...bookingEquipmentchanges(tempMap.get(shipmentsDetails.BookingEquipment.Id || '0') || []), ...deRetardLabels(tempMap.get(shipmentsDetails?.Equipment?.Id || '0') || []), ...getAllDimensions(shipmentsDetails.BookingEquipmentDimensionsList, tempMap)] || [],
                    'dangerousGoods': shipments.ShipmentDangerousGoodsPlusList.map((imo, imoIndex) => {
                      return {
                        'id': imoIndex + 1,
                        'IdDangerousGoodsList': operation === 'Edit' && imo.ShipmentDangerousGoods.Id || '00000000-0000-0000-0000-000000000000',
                        'DangerousGoodsId': imo.ShipmentDangerousGoods.IdDangerousGoods,
                        'FlashPT': imo.ShipmentDangerousGoods.FlashPT,
                        'PackagingGroup': imo.ShipmentDangerousGoods.PackagingGroup,
                        'DangerousGoodsCode': imo.DangerousGoods.Code,
                        'DangerousGoodsClass': imo.DangerousGoods.Class,
                        'shipmentChanged': [...(tempMap.get(imo?.ShipmentDangerousGoods?.Id || '0') || [])],
                      }
                    })
                  }
                  shipmentsDetails?.BookingEquipmentDimensionsList?.forEach(dimension => {
                    if (dimension.DimensionsCode === 'FRO') {
                      tempObj.Front = dimension.DimensionsLength || 0
                      tempObj.DimensionsFROId = dimension.Id
                    }
                    if (dimension.DimensionsCode === 'BAC') {
                      tempObj.Back = dimension.DimensionsLength || 0
                      tempObj.DimensionsBACId = dimension.Id
                    }
                    if (dimension.DimensionsCode === 'LEF') {
                      tempObj.Left = dimension.DimensionsWidth || 0
                      tempObj.DimensionsLEFId = dimension.Id
                    }
                    if (dimension.DimensionsCode === 'RIG') {
                      tempObj.Right = dimension.DimensionsWidth || 0
                      tempObj.DimensionsRIGId = dimension.Id
                    }
                    if (dimension.DimensionsCode === 'OVE') {
                      tempObj.Height = dimension.DimensionsHeight || 0
                      tempObj.DimensionsOVEId = dimension.Id
                    }
                  })

                  if (tempObj.Equipment === 'no') {
                    const newTempArray = []
                    let tempBool = false
                    tempArrayObj.forEach(obj => {
                      if (obj.EquipmentIndex === tempObj.EquipmentIndex) {
                        tempBool = true
                        if (!newTempArray.some(test => test.id === tempObj.id) && obj.id !== tempObj.id) {
                          newTempArray.push(tempObj)
                          newTempArray.push(obj)
                        } else {
                          newTempArray.push(obj)
                        }
                      } else {
                        newTempArray.push(obj)
                      }
                    })

                    if (tempBool === false) {
                      newTempArray.push(tempObj)
                    }

                    tempArrayObj = newTempArray
                  } else {
                    tempArrayObj.push(tempObj)
                  }
                  setContainerIndex(mainIndex + 1)
                  setEquipmentIndex(tempEquipmentIndex + 2)
                })
              })
              tempArrayObj.forEach(obj => {
                if (!tempShipmentArray.includes(obj.Shipment)) {
                  tempShipmentArray.push(obj.Shipment)
                }
              })
              wasEdited([...(tempMap.get(data.Booking.Id || '0') || [])])

              tempArrayObj.sort((a, b) => a.shipOrder === b.shipOrder ? a.shipTransOrder - b.shipTransOrder : a.shipOrder - b.shipOrder)
              setShipmentIndex(tempShipmentArray.length === 0 ? 1 : tempShipmentArray[tempShipmentArray.length - 1] + 1)
              setShipmentArray(tempShipmentArray)
              setEquipmentClass(tempEquipmentClass)
              setShipmentObjArray(tempArrayObj)

                const tempBookingEquipmentArray = []
                const tempBookingEquipmentIndexes = new Map()
                const equipmentPromises = []
                const ccShipmentPromises = []

                // Load Equipment Types for Shipments
                tempArrayObj.forEach((shipmentItem, index) => {
                    if (shipmentItem.EquipmentTypeId && 
                        shipmentItem.EquipmentTypeId !== '00000000-0000-0000-0000-000000000000' &&
                        (!shipmentItem['Equipment Type'] || shipmentItem['Equipment Type'] === '')) {
                        
                        const promise = containerEquipmentTypeService
                            .filter(`/byExternalId/${shipmentItem.EquipmentTypeId}`)
                            .then(response => {
                                const ccType = Array.isArray(response) ? response[0] : response;
                                if (ccType && ccType.name !== 'AxiosError') {
                                    setShipmentObjArray(prev => {
                                        const newArr = [...prev];
                                        if (newArr[index]) {
                                            newArr[index] = {
                                                ...newArr[index],
                                                'Equipment Type': ccType.Code || '',
                                            };
                                        }
                                        return newArr;
                                    });
                                }
                            })
                            .catch(() => {});
                        ccShipmentPromises.push(promise);
                    }
                })

                // Load BookingEquipments
                data.ShipmentPlusList.forEach((shipments) => {
                    shipments.ShipmentDetailPlusList.forEach((shipmentsDetails) => {
                        const bookingEquipment = shipmentsDetails.BookingEquipment
        
                        console.log('BookingEquipment raw:', {
                            Id: bookingEquipment.Id,
                            IdEquipment: bookingEquipment.IdEquipment,
                            IdEquipmentType: bookingEquipment.IdEquipmentType,
                            ContainerControlEquipmentTypeId: bookingEquipment.ContainerControlEquipmentTypeId,
                            ContainerControlEquipmentId: bookingEquipment.ContainerControlEquipmentId,
                            IdParkLocation: bookingEquipment.IdParkLocation,
                            IdTerminalLoadLocation: bookingEquipment.IdTerminalLoadLocation,
                            IdTerminalDischargeLocation: bookingEquipment.IdTerminalDischargeLocation,
                            BookingDate: bookingEquipment.BookingDate,
                            GateDate: bookingEquipment.GateDate
                        })
        
                        // Check if it's BookingEquipment
                        const isBookingEquipment = bookingEquipment && 
                            (bookingEquipment.ContainerControlEquipmentTypeId ||
                             bookingEquipment.ContainerControlEquipmentId ||
                             bookingEquipment.IdParkLocation || 
                             bookingEquipment.IdTerminalLoadLocation || 
                             bookingEquipment.IdTerminalDischargeLocation ||
                             bookingEquipment.BookingDate ||
                             bookingEquipment.GateDate)
        
                        if (isBookingEquipment) {
                            if (!tempBookingEquipmentIndexes.has(bookingEquipment.Id)) {
                                tempBookingEquipmentIndexes.set(bookingEquipment.Id, true)

                                const beItem = {
                                    id: tempBookingEquipmentArray.length + 1,
                                    Shipment: shipments.Shipment.TransportKey,
                                    EquipmentIndex: tempBookingEquipmentArray.length + 1,
                    
                                    EquipmentTypeId: bookingEquipment.ContainerControlEquipmentTypeId || bookingEquipment.IdEquipmentType,
                                    EquipmentId: bookingEquipment.ContainerControlEquipmentId || bookingEquipment.IdEquipment,
                    
                                    EquipmentType: '',
                                    EquipmentTypeCode: '',
                                    EquipmentTypeLenght: '',
                                    EquipmentNumber: '',
                                    Prefix: '',
                                    Number: '',
                                    CheckDigit: '',
                    
                                    ParkCode: '',
                                    ParkCodeId: bookingEquipment.IdParkLocation,
                                    TerminalLoadLocation: '',
                                    TerminalLoadLocationId: bookingEquipment.IdTerminalLoadLocation,
                                    TerminalDischargeLocation: '',
                                    TerminalDischargeLocationId: bookingEquipment.IdTerminalDischargeLocation,
                                    BookingDate: bookingEquipment.BookingDate?.split('T')[0] || '',
                                    GateDate: bookingEquipment.GateDate?.split('T')[0] || '',
                                }
                                tempBookingEquipmentArray.push(beItem)
                
                                // Fetch EquipmentType from ContainerControl
                                if (bookingEquipment.ContainerControlEquipmentTypeId) {
                                    const typePromise = containerEquipmentTypeService
                                        .filter(`/byExternalId/${bookingEquipment.ContainerControlEquipmentTypeId}`)
                                        .then(response => {
                                            const ccType = Array.isArray(response) ? response[0] : response;
                                            if (ccType && ccType.name !== 'AxiosError') {
                                                beItem.EquipmentType = `${ccType.Code || ''}`;
                                                beItem.EquipmentTypeCode = ccType.Code || '';
                                                console.log('ContainerControl EquipmentType loaded:', ccType.Code);
                                            }
                                        })
                                        .catch(err => console.warn('Error loading ContainerControl EquipmentType:', err));
                                    equipmentPromises.push(typePromise);
                                }

                                // If not from ContainerControl, go with local EquipmentType
                                else if (bookingEquipment.EquipmentType) {
                                    beItem.EquipmentType = `${bookingEquipment.EquipmentType.EquipmentTypeCode || ''}`;
                                    beItem.EquipmentTypeCode = bookingEquipment.EquipmentType.EquipmentTypeCode || '';
                                }
                
                                // Fetch Equipment from ContainerControl
                                if (bookingEquipment.ContainerControlEquipmentId) {
                                    const equipPromise = containerEquipmentService
                                        .filter(`/byExternalId/${bookingEquipment.ContainerControlEquipmentId}`)
                                        .then(response => {
                                            const ccEquip = Array.isArray(response) ? response[0] : response;
                                            if (ccEquip && ccEquip.name !== 'AxiosError') {
                                                beItem.EquipmentNumber = `${ccEquip.Prefix || ''} ${ccEquip.Number || ''} ${ccEquip.CheckDigit || ''}`;
                                                beItem.Prefix = ccEquip.Prefix || '';
                                                beItem.Number = ccEquip.Number || '';
                                                beItem.CheckDigit = ccEquip.CheckDigit || '';
                                                console.log('ContainerControl Equipment loaded:', beItem.EquipmentNumber);
                                            }
                                        })
                                        .catch(err => console.warn('Error loading ContainerControl Equipment:', err));
                                    equipmentPromises.push(equipPromise);
                                }
                                // If not from ContainerControl, go with local Equipment
                                else if (bookingEquipment.Equipment) {
                                    beItem.EquipmentNumber = `${bookingEquipment.Equipment.Prefix || ''} ${bookingEquipment.Equipment.Number || ''} ${bookingEquipment.Equipment.CheckDigit || ''}`;
                                    beItem.Prefix = bookingEquipment.Equipment.Prefix || '';
                                    beItem.Number = bookingEquipment.Equipment.Number || '';
                                    beItem.CheckDigit = bookingEquipment.Equipment.CheckDigit || '';
                                }
                                // Fetch ParkLocation
                                if (bookingEquipment.IdParkLocation) {
                                    const parkPromise = locationService.getId(bookingEquipment.IdParkLocation)
                                        .then(loc => {
                                            if (loc && loc.name !== 'AxiosError') {
                                                beItem.ParkCode = loc.LocationName || '';
                                            }
                                        }).catch(() => {});
                                    equipmentPromises.push(parkPromise);
                                }
                                // Fetch TerminalLoadLocation
                                if (bookingEquipment.IdTerminalLoadLocation) {
                                    const loadPromise = locationService.getId(bookingEquipment.IdTerminalLoadLocation)
                                        .then(loc => {
                                            if (loc && loc.name !== 'AxiosError') {
                                                beItem.TerminalLoadLocation = loc.LocationName || '';
                                            }
                                        }).catch(() => {});
                                    equipmentPromises.push(loadPromise);
                                }
                                // Fetch TerminalDischargeLocation
                                if (bookingEquipment.IdTerminalDischargeLocation) {
                                    const dischargePromise = locationService.getId(bookingEquipment.IdTerminalDischargeLocation)
                                        .then(loc => {
                                            if (loc && loc.name !== 'AxiosError') {
                                                beItem.TerminalDischargeLocation = loc.LocationName || '';
                                            }
                                        }).catch(() => {});
                                    equipmentPromises.push(dischargePromise);
                                }
                            }
                        }
                    })
                })

                Promise.all(equipmentPromises).then(() => {
                    setBookingEquipmentArray([...tempBookingEquipmentArray]);
                    console.log('BookingEquipments loaded with ContainerControl data:', tempBookingEquipmentArray);
                });

              setIsLoaded(false)
              ctx.setIsLoad(false)
            })
          })
        }
      }
    })
  }

  const getAllDimensions = (dimensions, changesMap) => {
    if (dimensions.length > 1) {
      const newArray = []
      dimensions.forEach(elem => {
        if (elem.DimensionsCode === 'FRO') {
          if (changesMap?.get(elem.Id)?.includes('DimensionsLength')) newArray.push('Front')
        }
        if (elem.DimensionsCode === 'BAC') {
          if (changesMap?.get(elem.Id)?.includes('DimensionsLength')) newArray.push('Back')
        }
        if (elem.DimensionsCode === 'LEF') {
          if (changesMap?.get(elem.Id)?.includes('DimensionsWidth')) newArray.push('Left')
        }
        if (elem.DimensionsCode === 'RIG') {
          if (changesMap?.get(elem.Id)?.includes('DimensionsWidth')) newArray.push('Right')
        }
        if (elem.DimensionsCode === 'OVE') {
          if (changesMap?.get(elem.Id)?.includes('DimensionsHeight')) newArray.push('Height')
        }
      })
      return newArray
    }
    if (dimensions.length === 1) {
      return changesMap.get(dimensions[0].Id) || []
    }
    if (dimensions.length === 0) {
      return []
    }
    return []
  }

  const bookingEquipmentchanges = (newList) => {
    const tempList = []
    newList.forEach(el => {
      switch (el) {
        case 'Id':
          tempList.push('bookingEquipmentId')
          break
        case 'GoodsDetails':
          tempList.push('Cargo Description')
          break
        case 'TransportDetails':
          tempList.push('Load Weight (KG)')
          break
        case 'LoadingDate':
          tempList.push('Loading Date')
          break
        case 'IMODangerGoods':
          tempList.push('IMO')
          break
        case 'Temp':
          tempList.push('temp')
          break
        default:
          tempList.push(el)
      }
    })
    return tempList
  }

  const deRetardLabels = (newList, type) => {
    const tempList = []
    newList.forEach(el => {
      switch (el) {
        case 'IMODangerGoods':
          tempList.push('IMO')
          break
        case 'Temp':
          tempList.push('temp')
          break
        default:
          if (type === 'Shipment' && el === 'Id') {
            tempList.push('ShipmentId')
          } else {
            tempList.push(el)
          }
      }
    })
    return tempList
  }

  const wasEdited = (newList) => {
    const tempList = []
    newList.forEach(el => {
      tempList.push(el)
    })
    setChangedList(tempList)
  }

  const handleCloseConfirmModal = () => {
    setOpenConfirmModal(false)
  }

  const openConfirmationModal = () => {
    console.log('=== openConfirmationModal CHAMADA ===')
    console.log('bookingEquipmentArray length:', bookingEquipmentArray?.length)
    console.log('bookingEquipmentArray:', bookingEquipmentArray)
    
    ctx.setIsLoad(true)
    setOpenConfirmModal(false)
    let today = new Date()
    let todayFormat = toLocal(today)
    let errorMessage = ''
    let isError = false

    if (saveAs !== 'Draft' && !entitiesDict.get('InvoiceCode')) {
      toastMessages('error', '', t('invoiceEmpty'))
      ctx.setIsLoad(false)
      return
    }
    if (saveAs !== 'Draft' && (!locationsDict.get('Discharge Port') || !locationsDict.get('Loading Port'))) {
      toastMessages('error', '', t('locationsEmpty'))
      ctx.setIsLoad(false)
      return
    }

    const tempObj = {
      'Date': todayFormat,
      'DocumentQuantity': 1,

      'TransportId': extraValues.get('transport id'),
      'LocationReceiptId': extraValues.get('Original Port id') || null,
      'LoadingPortId': saveAs === 'Draft' ? extraValues.get('Loading Port id') || null : extraValues.get('Loading Port id'),
      'DischargePortId': saveAs === 'Draft' ? extraValues.get('Discharge Port id') || null : extraValues.get('Discharge Port id'),
      'LocationDeliveryPortId': extraValues.get('Final Port id') || null,
      'ClientId': extraValues.get('Client Id'),
      'ProcessStatusId': saveAs === 'Draft' || isMove === true ? draft : waitingApproval,

      'VesselCode': voyageDict.get('Vessel'),
      'VoyageNumber': voyageDict.get('Voyage'),
      'ClientCode': entitiesDict.get('ClientCode'),
      'ClientVAT': entitiesDict.get('ClientVAT'),
      'ClientReference': entitiesDict.get('ClientReference'),
      'InvoiceCode': entitiesDict.get('InvoiceCode'),
      'InvoiceVAT': entitiesDict.get('InvoiceVat'),
      'OriginalPortCode': locationsDict.get('Original Port Code') !== undefined ? locationsDict.get('Original Port Code') : null,
      'LoadingPortCode': locationsDict.get('Loading Port Code'),
      'DischargePortCode': locationsDict.get('Discharge Port Code'),
      'FinalPortCode': locationsDict.get('Final Port Code') !== undefined ? locationsDict.get('Final Port Code') : null,
      'Transhipment': locationsDict.get('Transhipment') === true ? 'Y' : 'N',
      // 'QuoteNumber': detailsDict.get('Quote Number'),
      'QuoteId': linkedQuoteId,

      'ProcessKey': null,
      'BookingNumber': extraValues.get('BookingNumber'),
      'AccountingA': null,
      'Mrn': null,
      'Comments': null,
      'IncotermsId': null,
      'NotifyId': null,
      'InvoiceId': extraValues.get('InvoiceId') || null,
      'ShipperId': null,
      'CurrencyId': null,
      'ConsigneeId': null,
      'SubAccountId': null,
      'IncotermsCode': null,
      'CustomStatusId': null,
      'ExternalLineId': null,
      'ShippingConditionId': null,
      'UserCompanyId': extraValues.get('UserCompanyId')
    }

    const shipments = new Map()
    shipmentArray.forEach(ship => {
      shipments.set(ship, [])
    })
    shipmentObjArray.forEach(data => {
      shipments.set(data.Shipment, shipments.get(data.Shipment) !== undefined ? [...shipments.get(data.Shipment), data] : [data])
    })

    // Agrupar bookingEquipments por Shipment
    const bookingEquipmentsByShipment = new Map()
    bookingEquipmentArray.forEach(data => {
        const shipmentKey = data.Shipment
        if (!bookingEquipmentsByShipment.has(shipmentKey)) {
            bookingEquipmentsByShipment.set(shipmentKey, [])
        }
        bookingEquipmentsByShipment.get(shipmentKey).push(data)
    })

    if (operation === 'Create' || operation === 'Copy' || isMove === true) {
      let newPost = { "Booking": tempObj }
      const ShipmentPlus = []
      let ShipmentDetailPlus = []

      let Shipment
      let NewShipment

      if(isMove === false){
        const allShipmentKeys = new Set([...shipments.keys(), ...bookingEquipmentsByShipment.keys()])
        
        allShipmentKeys.forEach(index => {
          const shipmentEquipments = shipments.get(index) || []
          const shipmentBookingEquipments = bookingEquipmentsByShipment.get(index) || []
          
          if (shipmentEquipments.length === 0 && shipmentBookingEquipments.length === 0) {
            return
          }

          Shipment = {
            // Id: shipments.get(index)[0].ShipmentId,
            // IdBooking: extraValues.get('id'),
            IMODangerGoods: shipmentEquipments[0]?.IMO || false,
            IdDangerousGoods: shipmentEquipments[0]?.DangerousGoodsId !== undefined ? shipmentEquipments[0]?.DangerousGoodsId : null,
            IdCommodity: shipmentEquipments[0]?.CommodityId !== undefined ? shipmentEquipments[0]?.CommodityId : null,
            FlashPT: shipmentEquipments[0]?.FlashPT,
            PackingGroup: shipmentEquipments[0]?.PackagingGroup,
            Temp: shipmentEquipments[0]?.onOff ? shipmentEquipments[0]?.temp : null,
            IdPackage: null,
          }

          let ShipmentDangerousGoods = []
          if (shipmentEquipments[0]?.dangerousGoods && shipmentEquipments[0]?.IMO) {

            ShipmentDangerousGoods = shipmentEquipments[0].dangerousGoods.map((imo, imoIndex) => {
              return {
                'ShipmentDangerousGoods': {
                  'Id': imo.IdDangerousGoodsList,
                  'IdShipment': shipmentEquipments[0].ShipmentId,
                  'IdDangerousGoods': imo.DangerousGoodsId,
                  'FlashPT': imo.FlashPT,
                  'PackagingGroup': imo.PackagingGroup,
                }
              }

            }
            )
          }

          if (shipmentEquipments[0]?.Reefer) {
            if ((shipmentEquipments[0]?.onOff !== false && shipmentEquipments[0]?.onOff !== true) || (shipmentEquipments[0]?.onOff && !shipmentEquipments[0]?.temp)) {

              isError = true
              errorMessage = t("tempEmpty")
            }
          }

          ShipmentDetailPlus = []

          shipmentEquipments.forEach(shipment => {

            const ShipmentDetails = {
              "ShipmentDetail": {
                // Id: shipment.ShipmentDetailsId,
                // IdBookingEquipment: shipment.bookingEquipmentId,
                // IdShipment: shipment.ShipmentId,
                // Description: shipment['Cargo Description'],
                // Weight: shipment['Load Weight (KG)'],
                Package: '',
                Description: '',
                Weight: '',
                Measures: '',
              },
              "Equipment": null,
              "BookingEquipment": null,
              "BookingEquipmentDimensionsList": []
            }
            if (shipment.Equipment !== 'no') {
              ShipmentDetails.BookingEquipment = {
                // Id: shipment.bookingEquipmentId,
                LoadingDate: shipment['Loading Date']?.replace('-', '/'),
                SOC: shipment.SOC === true ? 'Y' : 'N',
                Brand: shipment.Brand,
                Model: shipment.Model,
                Chassis: shipment.Chassis,
                IdEquipment: shipment.EquipmentId,
                IdEquipmentType: shipment.EquipmentTypeId,
                IdEquipmentOwnerAccount: null,
                GoodsDetails: shipment['Cargo Description'],
                TransportDetails: shipment['Load Weight (KG)'],
              }

              if (!shipment['Load Weight (KG)']) {
                isError = true
                errorMessage = t("LoadWeightEmpty") || "Load Weight is required"
              }

              if (shipment.RORO) {
                if (!shipment.Brand || !shipment.Model || !shipment.Chassis) {
                  isError = true
                  errorMessage = t("ROROEmpty")
                }
              }

              if (!shipment['Cargo Description']) {
                isError = true
                errorMessage = t("CargoDescriptionEmpty") || "Cargo Description is required"
              }

              if (shipment.DimensionsHeight || shipment.DimensionsWidth || shipment.DimensionsLength) {
                ShipmentDetails.BookingEquipmentDimensionsList = [
                  {
                    // Id: shipment.DimensionsId,
                    BookingEquipmentId: '00000000-0000-0000-0000-000000000000',
                    DimensionsWidth: shipment.DimensionsWidth || 0,
                    DimensionsHeight: shipment.DimensionsHeight || 0,
                    DimensionsLength: shipment.DimensionsLength || 0,
                  }
                ]
              }
              if (shipment?.Front || shipment?.Back || shipment?.Left || shipment?.Right || shipment?.Height) {
                ShipmentDetails.BookingEquipmentDimensionsList = [
                  {
                    BookingEquipmentId: '00000000-0000-0000-0000-000000000000',
                    DimensionsCode: 'FRO',
                    DimensionsLength: shipment?.Front || 0,
                    DimensionsWidth: 0,
                    DimensionsHeight: 0,
                  },
                  {
                    BookingEquipmentId: '00000000-0000-0000-0000-000000000000',
                    DimensionsCode: 'BAC',
                    DimensionsLength: shipment?.Back || 0,
                    DimensionsWidth: 0,
                    DimensionsHeight: 0,
                  },
                  {
                    BookingEquipmentId: '00000000-0000-0000-0000-000000000000',
                    DimensionsCode: 'LEF',
                    DimensionsLength: 0,
                    DimensionsWidth: shipment?.Left || 0,
                    DimensionsHeight: 0,
                  },
                  {
                    BookingEquipmentId: '00000000-0000-0000-0000-000000000000',
                    DimensionsCode: 'RIG',
                    DimensionsLength: 0,
                    DimensionsWidth: shipment?.Right || 0,
                    DimensionsHeight: 0,
                  },
                  {
                    BookingEquipmentId: '00000000-0000-0000-0000-000000000000',
                    DimensionsCode: 'OVE',
                    DimensionsLength: 0,
                    DimensionsWidth: 0,
                    DimensionsHeight: shipment?.Height || 0,
                  },
                ]
              }
              if (shipment.SOC) {
                if (!shipment.Number || !shipment.CheckDigit) {
                  isError = true
                  errorMessage = t("SOCEmpty")
                }
              }
              if (shipment.SOC) {
                ShipmentDetails.Equipment = {
                  // Id: shipment.EquipmentId || null,
                  Prefix: shipment.Prefix,
                  Number: shipment.Number,
                  CheckDigit: shipment.CheckDigit,
                  IdEquipmentType: shipment.EquipmentTypeId || null,
                  Payload: shipment.Payload,
                  Tare: shipment.Tare,
                  SOC: shipment.SOC,
                }
              }
            }
            ShipmentDetailPlus.push(ShipmentDetails)
          })

          shipmentBookingEquipments.forEach(bookingEq => {
            const ShipmentDetails = {
              "ShipmentDetail": {
                Package: '',
                Description: '',
                Weight: '',
                Measures: '',
              },
              "Equipment": null,
                "BookingEquipment": {
                    // ContainerControl Equipment
                    ContainerControlEquipmentTypeId: bookingEq.EquipmentTypeId || null,
                    ContainerControlEquipmentId: bookingEq.EquipmentId || null,
            
                    // Localization
                    IdParkLocation: bookingEq.ParkCodeId || null,
                    IdTerminalLoadLocation: bookingEq.TerminalLoadLocationId || null,
                    IdTerminalDischargeLocation: bookingEq.TerminalDischargeLocationId || null,
            
                    // Dates
                    BookingDate: bookingEq.BookingDate || null,
                    GateDate: bookingEq.GateDate || null,

                    Brand: '',
                    Model: '',
                    Chassis: '',
            
                    SOC: 'N',
                    GoodsDetails: '',
                    TransportDetails: '',
                      },
                      "BookingEquipmentDimensionsList": []
                    }
                    ShipmentDetailPlus.push(ShipmentDetails)
                  })

          NewShipment = { 
            "ShipmentDangerousGoodsPlusList": ShipmentDangerousGoods, 
            "Shipment": Shipment, 
            "ShipmentDetailPlusList": ShipmentDetailPlus 
          }
          ShipmentPlus.push(NewShipment)
        })
        
        if (ShipmentPlus.length === 0) {
          isError = true
          errorMessage = t('ErrorCreateNoShipment')
        }
      }
      newPost = { ...newPost, "ShipmentPlusList": ShipmentPlus }
      
      if (isError && saveAs !== 'Draft') {
        ctx.setIsLoad(false)
        toastMessages('error', '', errorMessage)
      } else {


        bookingV2Service.post(newPost).then(async resBooking => {
          ctx.setIsLoad(false)
          if (resBooking.name === 'AxiosError') {
            toastMessages('error', '', resBooking.response.data.Message || resBooking.message)
            return
          }
          extraValues.set('BookingNumber', resBooking.Booking.BookingNumber)

          if(isMove === true)
          {
            let tempData = sessionStorage.getItem('lines')
            if (tempData === 'undefined' || tempData === null || tempData === undefined || tempData === 'null') {
                ctx.toastMessages('error', '', t("SelectedLine"))
                return
            }
            tempData = JSON.parse(tempData)
            sessionStorage.removeItem('lines')
            for (const obj of tempData) {
              await onMoveEquipment(resBooking.Booking.Id, obj)
            }
            submitedApproval()
            return true

          }
          if(isMove === false){
            setOpenConfirmModal(false)
            setExtraValues(new Map(extraValues))
            setConfirmationModal(true)
          }
          else isMove = false
        })
      }
    }
    
    if (operation === 'Edit' && isMove !== true) {
      let newPost = { Booking: { ...tempObj, 'Id': extraValues.get('id') } }
      const ShipmentPlus = []
      let ShipmentDetailPlus = []

      let Shipment
      let NewShipment
      
      const allShipmentKeys = new Set([...shipments.keys(), ...bookingEquipmentsByShipment.keys()])
      
      allShipmentKeys.forEach(index => {
        const shipmentEquipments = shipments.get(index) || []
        const shipmentBookingEquipments = bookingEquipmentsByShipment.get(index) || []
        
        if (shipmentEquipments.length === 0 && shipmentBookingEquipments.length === 0) {
          return
        }

        Shipment = {
          Id: shipmentEquipments[0]?.ShipmentId || '00000000-0000-0000-0000-000000000000',
          IMODangerGoods: shipmentEquipments[0]?.IMO || false,
          IdBooking: extraValues.get('id'),
          IdCommodity: shipmentEquipments[0]?.CommodityId !== undefined ? shipmentEquipments[0]?.CommodityId : null,
          Temp: shipmentEquipments[0]?.onOff ? shipmentEquipments[0]?.temp : null,
          IdPackage: null,
        }

        let ShipmentDangerousGoods = []
        if (shipmentEquipments[0]?.dangerousGoods) {
          ShipmentDangerousGoods = shipmentEquipments[0].dangerousGoods.map((imo, imoIndex) => {
            return {
              'ShipmentDangerousGoods': {
                'Id': imo.IdDangerousGoodsList,
                'IdShipment': shipmentEquipments[0].ShipmentId,
                'IdDangerousGoods': imo.DangerousGoodsId,
                'FlashPT': imo.FlashPT,
                'PackagingGroup': imo.PackagingGroup,
              }
            }
          })
        }

        if (shipmentEquipments[0]?.Reefer) {
          if ((shipmentEquipments[0]?.onOff !== false && shipmentEquipments[0]?.onOff !== true) || (shipmentEquipments[0]?.onOff && !shipmentEquipments[0]?.temp)) {
            isError = true
            errorMessage = t("tempEmpty")
          }
        }

        ShipmentDetailPlus = []
        shipmentEquipments.forEach(shipment => {
          const ShipmentDetails = {
            "ShipmentDetail": {
              Id: shipment.ShipmentDetailsId || '00000000-0000-0000-0000-000000000000',
              IdBookingEquipment: shipment.bookingEquipmentId || '00000000-0000-0000-0000-000000000000',
              IdShipment: shipment.ShipmentId || '00000000-0000-0000-0000-000000000000',
              Package: shipment.NrPackage,
              Description: shipment.Description,
              Weight: shipment.Weight,
              Measures: shipment.Measures,
            },
            "Equipment": null,
            "BookingEquipment": null,
            BookingEquipmentDimensionsList: []
          }
          if (shipment.Equipment !== 'no') {
            ShipmentDetails.BookingEquipment = {
              Id: shipment.bookingEquipmentId || '00000000-0000-0000-0000-000000000000',
              LoadingDate: shipment['Loading Date']?.replace('-', '/'),
              SOC: shipment.SOC === true ? 'Y' : 'N',
              Brand: shipment.Brand,
              Model: shipment.Model,
              Chassis: shipment.Chassis,
              IdEquipment: shipment.EquipmentId || '00000000-0000-0000-0000-000000000000',
              IdEquipmentType: shipment.EquipmentTypeId || '00000000-0000-0000-0000-000000000000',
              IdEquipmentOwnerAccount: null,
              GoodsDetails: shipment['Cargo Description'],
              TransportDetails: shipment['Load Weight (KG)'],
            }

            if (!shipment['Load Weight (KG)']) {
              isError = true
              errorMessage = t("LoadWeightEmpty") || "Load Weight is required"
            }

            if (shipment.RORO) {
              if (!shipment.Brand || !shipment.Model || !shipment.Chassis) {
                isError = true
                errorMessage = t("ROROEmpty")
              }
            }

            if (!shipment['Cargo Description']) {
              isError = true
              errorMessage = t("CargoDescriptionEmpty") || "Cargo Description is required"
            }

            if (shipment.DimensionsHeight || shipment.DimensionsWidth || shipment.DimensionsLength) {
              ShipmentDetails.BookingEquipmentDimensionsList = [
                {
                  Id: shipment?.DimensionsId || "00000000-0000-0000-0000-000000000000",
                  BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                  DimensionsWidth: shipment.DimensionsWidth || 0,
                  DimensionsHeight: shipment.DimensionsHeight || 0,
                  DimensionsLength: shipment.DimensionsLength || 0,
                }
              ]
            }
            if (shipment?.Front || shipment?.Back || shipment?.Left || shipment?.Right || shipment?.Height) {
              ShipmentDetails.BookingEquipmentDimensionsList = [
                {
                  Id: shipment?.DimensionsFROId || "00000000-0000-0000-0000-000000000000",
                  BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                  DimensionsCode: 'FRO',
                  DimensionsLength: shipment?.Front || 0,
                  DimensionsWidth: 0,
                  DimensionsHeight: 0,
                },
                {
                  Id: shipment?.DimensionsBACId || "00000000-0000-0000-0000-000000000000",
                  BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                  DimensionsCode: 'BAC',
                  DimensionsLength: shipment?.Back || 0,
                  DimensionsWidth: 0,
                  DimensionsHeight: 0,
                },
                {
                  Id: shipment?.DimensionsLEFId || "00000000-0000-0000-0000-000000000000",
                  BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                  DimensionsCode: 'LEF',
                  DimensionsLength: 0,
                  DimensionsWidth: shipment?.Left || 0,
                  DimensionsHeight: 0,
                },
                {
                  Id: shipment?.DimensionsRIGId || "00000000-0000-0000-0000-000000000000",
                  BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                  DimensionsCode: 'RIG',
                  DimensionsLength: 0,
                  DimensionsWidth: shipment?.Right || 0,
                  DimensionsHeight: 0,
                },
                {
                  Id: shipment?.DimensionsOVEId || "00000000-0000-0000-0000-000000000000",
                  BookingEquipmentId: shipment.bookingEquipmentId || "00000000-0000-0000-0000-000000000000",
                  DimensionsCode: 'OVE',
                  DimensionsLength: 0,
                  DimensionsWidth: 0,
                  DimensionsHeight: shipment?.Height || 0,
                },
              ]
            }
            if (shipment.SOC) {
              if (!shipment.Number || !shipment.CheckDigit) {
                isError = true
                errorMessage = t("SOCEmpty")
              }
            }
            if (shipment.Number) {
              ShipmentDetails.Equipment = {
                Id: shipment.EquipmentId || '00000000-0000-0000-0000-000000000000',
                Prefix: shipment.Prefix || '',
                Number: shipment.Number || '',
                CheckDigit: shipment.CheckDigit || '',
                Payload: shipment.Payload,
                Tare: shipment.Tare,
                IdEquipmentType: shipment.EquipmentTypeId || '00000000-0000-0000-0000-000000000000',
                SOC: shipment.SOC,
              }
            }
          }
          ShipmentDetailPlus.push(ShipmentDetails)
        })

        shipmentBookingEquipments.forEach(bookingEq => {
          const ShipmentDetails = {
            "ShipmentDetail": {
              Id: '00000000-0000-0000-0000-000000000000',
              IdBookingEquipment: '00000000-0000-0000-0000-000000000000',
              IdShipment: shipmentEquipments[0]?.ShipmentId || '00000000-0000-0000-0000-000000000000',
              Package: '',
              Description: '',
              Weight: '',
              Measures: '',
            },
            "Equipment": null,
            "BookingEquipment": {
                ContainerControlEquipmentTypeId: bookingEq.EquipmentTypeId,
                ContainerControlEquipmentId: bookingEq.EquipmentId,

                IdParkLocation: bookingEq.ParkCodeId,
                IdTerminalLoadLocation: bookingEq.TerminalLoadLocationId,
                IdTerminalDischargeLocation: bookingEq.TerminalDischargeLocationId,

                BookingDate: bookingEq.BookingDate,
                GateDate: bookingEq.GateDate,

                Brand: '',
                Model: '',
                Chassis: '',

                SOC: 'N',
                GoodsDetails: '',
                TransportDetails: '',
            },
            "BookingEquipmentDimensionsList": []
          }
          ShipmentDetailPlus.push(ShipmentDetails)
        })

        NewShipment = { ShipmentDangerousGoodsPlusList: ShipmentDangerousGoods, Shipment, ShipmentDetailPlusList: ShipmentDetailPlus }
        ShipmentPlus.push(NewShipment)
      })
      
      if (ShipmentPlus.length === 0) {
        isError = true
        errorMessage = t('ErrorCreateNoShipment')
      }

      if (isError && saveAs !== 'Draft') {
        ctx.setIsLoad(false)
        toastMessages('error', '', errorMessage)
      } else {
        newPost = { ...newPost, ShipmentPlusList: ShipmentPlus }
        bookingV2Service.update(extraValues.get('id'), newPost).then(resBooking => {
          ctx.setIsLoad(false)
          if (resBooking.name === 'AxiosError') {
            toastMessages('error', '', resBooking.response.data.Message || resBooking.message)
            return
          }
          setConfirmationModal(true)
        })
      }
    }
  }

  const submitedApproval = () => {
    let values = new Map([...voyageDict, ...entitiesDict, ...locationsDict])
    values.set("Shipment", shipmentObjArray)
    values.set("Notes", "")
    values = Object.fromEntries(values)
    toastMessages('success', '', t("MessageRedirectingMenu"))
    handleTabClose(JSON.parse(id))
  }

  const addShipment = () => {
    if ((equipmentDict.get('Equipment Type') === '')) {
      toastMessages('error', '', t("MessageRequiredFields"))
      return
    }
    if (equipmentDict.get('Quantity') === '' || equipmentDict.get('Quantity') === 0) {
      equipmentDict.set('Quantity', 1)
    }
    let tempObj
    let tempNewArray = shipmentObjArray
    let tempContainer = containerIndex
    let tempEquipmentClass = equipmentClass
    let tempEquipmentIndex = EquipmentIndex
    let tempShipmentIndex = shipmentIndex

    if (tempEquipmentClass.length === 0) {

      tempEquipmentClass.push(equipmentDict.get('EquipmentClassCode'))
      setEquipmentClass(tempEquipmentClass)
    }
    // if (!tempEquipmentClass.includes(equipmentDict.get('EquipmentClassCode')) && tempEquipmentClass.length !== 0) {
    //   // toastMessages('error', `${t('equipmentClass')}${tempEquipmentClass[0]}`, '')
    //   return
    // }

    //* IF SHIPMENT FIELD IS EMPTY WILL CHECK FOR SAME TYPE, PUT IT THERE OR CREATE A NEW SHIPMENT
    {
      //* SHIPMENT FIELD HAS A SHIPMENT SELECTED WILL PUT THE NEW EQUIPMENTS THERE OR IF "NEW SHIPMENT" HAS BEEN SELECTED WILL CREATE NEW SHIPMENT
      if (equipmentDict.get('Shipment') === '' || (equipmentDict.get('Shipment') !== '' && equipmentDict.get('Equipment Type') !== shipmentObjArray.filter(obj => obj.Shipment === equipmentDict.get('Shipment'))[0]['Equipment Type'])) {
        const tempRes = createNewShipment(0, tempNewArray, tempEquipmentIndex)
        tempObj = tempRes[0]
        tempNewArray = tempRes[1]
        tempEquipmentIndex = tempRes[2]
        tempShipmentIndex = tempRes[3]

        tempEquipmentIndex++

      } else {

        tempObj = {
          ...Object.fromEntries(equipmentDict),
          'id': tempContainer,
          'Shipment': equipmentDict.get('Shipment'),
          'EquipmentIndex': tempEquipmentIndex
        }
        tempNewArray.push(tempObj)
        tempContainer++
        setContainerIndex(tempContainer)
        setEquipmentIndex(tempEquipmentIndex + 1)
      }
    }

    //* NEW LINE ALREADY CREATED, WILL CHECK IF CHECKBOX FIELDS HAVE BEEN TICKED AND WILL OPEN DRAWER
    if (equipmentDict.get('Reefer') || equipmentDict.get('IMO') || equipmentDict.get('OpenTop') || equipmentDict.get('RORO') || equipmentDict.get('SOC') || equipmentDict.get('Equipment Type') === 'BULK' || equipmentDict.get('Equipment Type') === 'GENERAL') {
      if (equipmentDict.get('IMO') && !equipmentDict.get('Reefer') && !equipmentDict.get('OpenTop') && !equipmentDict.get('RORO') && !equipmentDict.get('SOC')) {
        tempObj.ShipmentIsEmpty = true
        setSelectedLine(tempObj)
        setDrawerName('Shipment Options')
        setOpenDrawer(true)
      } else {
        tempObj.ShipmentIsEmpty = true
        setSelectedLine(tempObj)
        setDrawerName('Equipment Options')
        setOpenDrawer(true)
      }
    } else {
      if (tempObj.Quantity > 1) {
        tempEquipmentIndex++
        let tempIndex = containerIndex + 1
        const tempArray = []
        const tempNumber = tempObj.Quantity
        const tempShipArray = []
        for (let i = tempNumber; 0 < i; i--) {
          if (equipmentDict.get('Shipment') === '') {
            tempArray.push({ ...tempObj, 'Quantity': 1, 'id': tempIndex, 'Shipment': tempShipmentIndex, 'EquipmentIndex': tempEquipmentIndex, })
            tempShipArray.push(tempShipmentIndex)
            tempShipmentIndex++
          }
          else {
            tempArray.push({ ...tempObj, 'Quantity': 1, 'id': tempIndex, 'EquipmentIndex': tempEquipmentIndex, })
          }
          tempIndex++
          tempEquipmentIndex++
        }
        setShipmentIndex(tempShipmentIndex)
        setShipmentArray(prev => [...prev, ...tempShipArray])
        tempNewArray = tempNewArray.filter(obj => obj.id !== tempObj.id)
        tempNewArray.push(...tempArray)
        setContainerIndex(tempIndex + 1)
      }
    }
    setShipmentObjArray(tempNewArray)
    setEquipmentIndex(tempEquipmentIndex + 1)

    //* CLEANUP FIELDS
    equipments.forEach(elem => {
      if (elem.type === 'checkbox') {
        addValue(elem.code, false, equipmentDict, setEquipmentDict)
      } else {
        addValue(elem.label, '', equipmentDict, setEquipmentDict)
      }
    })
    addValue('Shipment', "", equipmentDict, setEquipmentDict)
    addValue('Equipment Lenght', "", equipmentDict, setEquipmentDict)
    addValue('EquipmentType', "", equipmentDict, setEquipmentDict)
  }

  const addBookingEquipments = async () => {
      // Validations
      if (!bookingEquipmentDict.get('EquipmentTypeId')) {
          toastMessages('error', '', t("EquipmentType Field Required"))
          return
      }
      if (!bookingEquipmentDict.get('Shipment')) {
          toastMessages('error', '', t("Shipment Field Required"))
          return
      }

      let tempObj = {
          'id': containerIndex,
          'Shipment': bookingEquipmentDict.get('Shipment'),
          'EquipmentIndex': EquipmentIndex,
          
          // ContainerControl ID's
            'EquipmentTypeId': bookingEquipmentDict.get('EquipmentTypeId'),
            'EquipmentId': bookingEquipmentDict.get('EquipmentId'),

            'EquipmentType': bookingEquipmentDict.get('EquipmentType'),
            'EquipmentTypeCode': bookingEquipmentDict.get('EquipmentTypeCode'),
            'EquipmentNumber': bookingEquipmentDict.get('EquipmentNumber'),
            'Prefix': bookingEquipmentDict.get('Prefix'),
            'Number': bookingEquipmentDict.get('Number'),
            'CheckDigit': bookingEquipmentDict.get('CheckDigit'),
          
            'ParkCode': bookingEquipmentDict.get('ParkCode'),
            'ParkCodeId': bookingEquipmentDict.get('ParkCodeId'),
            'TerminalLoadLocation': bookingEquipmentDict.get('TerminalLoadLocation'),
            'TerminalLoadLocationId': bookingEquipmentDict.get('TerminalLoadLocationId'),
            'TerminalDischargeLocation': bookingEquipmentDict.get('TerminalDischargeLocation'),
            'TerminalDischargeLocationId': bookingEquipmentDict.get('TerminalDischargeLocationId'),
            'BookingDate': bookingEquipmentDict.get('BookingDate'),
            'GateDate': bookingEquipmentDict.get('GateDate'),
      }

      // Indexes
      setBookingEquipmentArray(prev => [...prev, tempObj])
      setContainerIndex(containerIndex + 1)
      setEquipmentIndex(EquipmentIndex + 1)

      // Reset
      const resetMap = new Map()
      bookingEquipments.forEach(elem => {
          resetMap.set(elem.code, '')
      })
      resetMap.set('EquipmentTypeCode', '')
      resetMap.set('EquipmentTypeLenght', '')
      resetMap.set('EquipmentType', '')
      resetMap.set('EquipmentNumber', '')
      resetMap.set('Prefix', '')
      resetMap.set('Number', '')
      resetMap.set('CheckDigit', '')
      
      setBookingEquipmentDict(resetMap)
      toastMessages('success', '', t("Booking Equipment Added"))
  }

  const createNewShipment = (tempKey, tempNewArray, tempEquipmentIndex) => {

    let tempObj
    let passTempEquipmentIndex = tempEquipmentIndex
    let tempShipIndex = shipmentIndex
    passTempEquipmentIndex++

    if (tempKey !== 0) {
      tempObj = {
        ...Object.fromEntries(equipmentDict),
        'id': containerIndex,
        'Shipment': tempKey,
        'EquipmentIndex': passTempEquipmentIndex,
      }
      // setShipmentObjArray(prev => [...prev, tempObj])
      tempNewArray.push(tempObj)
      // setEquipmentDict(new Map(equipmentDict.set('Shipment', tempKey)))
      setContainerIndex(containerIndex + 1)
      setEquipmentIndex(tempEquipmentIndex + 1)
    }
    else {
      tempObj = {
        ...Object.fromEntries(equipmentDict),
        'id': containerIndex,
        'Shipment': tempShipIndex,
        'EquipmentIndex': passTempEquipmentIndex
      }
      tempNewArray.push(tempObj)

      if (equipmentDict.get('Quantity') == 1 || equipmentDict.get('Quantity') === '') {
        setShipmentArray(prev => [...prev, tempShipIndex])
      }
      setShipmentIndex(tempShipIndex + 1)
      setContainerIndex(containerIndex + 1)
      setEquipmentIndex(tempEquipmentIndex + 1)
    }
    return [tempObj, tempNewArray, passTempEquipmentIndex, equipmentDict.get('Quantity') == 1 || equipmentDict.get('Quantity') === '' ? tempShipIndex + 1 : tempShipIndex]
  }

  const toLocal = (date) => {
    const local = new Date(date)
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    return local.toJSON()
  }

  const submitForApproval = () => {
    if (checkValue(voyageDict) === voyageDict.size) {
      setOpenConfirmModal(true)
    } else {
      toastMessages('error', '', t("MessageRequiredFields"))
    }
  }

  const checkValue = (dict) => {
    let filedTexts = 0
    dict.forEach((value, key) => {
      if (value !== '') {
        filedTexts++
      }
    })
    return filedTexts
  }

  const onFillFields = (data) => {
    if (data) {
      equipmentDict.set('Equipment Type', data['Equipment Type'])
      equipmentDict.set('EquipmentTypeId', data.EquipmentTypeId)
      equipmentDict.set('Shipment', data['Shipment'])
    }
    else {
      equipmentDict.set('Equipment Type', '')
      equipmentDict.set('Shipment', '')
    }
    setEquipmentDict(new Map(equipmentDict))
  }

  function toJSONLocalBE(date) {
    return date.slice(0, 10)
  }

  function toJSONLocal(date) {
    var local = new Date(date)
    local.setMinutes(date.getMinutes() - date.getTimezoneOffset())
    return local.toJSON().slice(0, 10)
  }

  function reformatDate(dateStr) {
    var dArr = dateStr.split("-")  // ex input: "2010-01-18"
    return dArr[2] + "/" + dArr[1] + "/" + dArr[0].substring(0) //ex output: "18/01/10"
  }

  const summary = () => {
    const tempMap = []
    shipmentObjArray.forEach(obj => {
      if (!tempMap.includes(obj['Equipment Type'])) {
        tempMap.push(obj['Equipment Type'])
      }
    })
    let tempString = `[ `
    tempMap.forEach(type => {
      tempString = tempString.concat(` ${shipmentObjArray.filter(filt => filt['Equipment Type'] === type && filt?.Equipment !== 'no').length}* ${type},`)
    })
    tempString = tempString.slice(0, tempString.length - 1)
    tempString = tempString.concat(' ]')
    return tempString
  }

  const getAccountCompany = (tempId) => {
    if (tempId) {
      accountService.getId(tempId).then(responseAccount => {
        addValue('ClientCode', responseAccount.AccountCode, entitiesDict, setEntitiesDict)
        addValue('ClientVAT', responseAccount.AccountVATNumber, entitiesDict, setEntitiesDict)
        addValue('Client Id', responseAccount.Id, extraValues, setExtraValues)
      })
    } else {
      addValue('ClientCode', '', entitiesDict, setEntitiesDict)
      addValue('ClientVAT', '', entitiesDict, setEntitiesDict)
      addValue('Client Id', '', extraValues, setExtraValues)
    }
  }

  const functionLeavingPage = () => {
    ctx2.closeTab(JSON.parse(id))
  }

  useEffect(() => {
    // Prefer roles passed from app root (TabsHomePage -> Go -> CreateBooking)
    try {
      const rolesFromProps = roles
      if (rolesFromProps && Array.isArray(rolesFromProps)) {
        if (rolesFromProps.some(r => typeof r === 'string' && /client/i.test(r))) {
          setIsClient(true)
          return
        }
      }
    } catch (e) {
    }

    // Fallback: try JWT token in localStorage (some deployments use different keys)
    try {
      const token = localStorage.getItem('token') || localStorage.getItem('tokenMaeil')
      if (token) {
        const payload = JSON.parse(atob(token.split('.')[1]))
        const tokenRoles = payload.roles || payload.role || []
        const names = Array.isArray(tokenRoles) ? tokenRoles : [tokenRoles]
        if (names.some(r => typeof r === 'string' && /client/i.test(r))) {
          setIsClient(true)
          return
        }
      }
    } catch (e) {
    }

    // Fallback: sessionStorage 'roles' key may contain permission strings
    try {
      const perms = JSON.parse(sessionStorage.getItem('roles') || '[]')
      if (Array.isArray(perms) && perms.some(p => typeof p === 'string' && p.toLowerCase().includes('client'))) setIsClient(true)
    } catch (e) {
      // ignore
    }
    }, [roles])

  // eslint-disable-next-line
  useEffect(() => {
    if (pendingEquipments.length === 0) return
    const equipment = pendingEquipments[0]
    addValue('EquipmentTypeId', equipment.EquipmentTypeId, equipmentDict, setEquipmentDict)
    addValue('Equipment Type', `${equipment.EquipmentTypeLenght}${equipment.EquipmentTypeCode}`, equipmentDict, setEquipmentDict)
    addValue('EquipmentType', equipment.EquipmentTypeCode, equipmentDict, setEquipmentDict)
    addValue('Equipment Lenght', equipment.EquipmentTypeLenght, equipmentDict, setEquipmentDict)
    addValue('Quantity', equipment.Quantity, equipmentDict, setEquipmentDict)
    addShipment()
    setPendingEquipments(prev => prev.slice(1))
  }, [pendingEquipments])

    const openDrawerSplitShipments = () => {
      ctx.setIsLoad(true)
      const tempId = JSON.parse(sessionStorage.getItem('contextLine'))
      shipmentBuffer.filter(`?page=1&pagesize=20&filter=IdBooking eq ${tempId.Id}`).then(dataShipment => {
          if (dataShipment.name === 'AxiosError') {
              ctx.toastMessages('error', dataShipment.message, '')
              ctx.setIsLoad(false)
              return
          }
          const tempShipArray = dataShipment.Items

          let tempShipString = filterService.advancedSearch(tempShipArray.map(obj => {
              return { name: 'IdShipment', type: 'int32', operation: 'Equals', value: obj.Id }
          }))

          tempShipString = tempShipString.replaceAll('and', 'or')
          shipmentDetailsBuffer.filter(`?${tempShipString}`).then(dataShipmentDetail => {
              if (dataShipment.name === 'AxiosError') {
                  ctx.toastMessages('error', dataShipmentDetail.message, '')
                  ctx.setIsLoad(false)
                  return
              }

              const tempShipDetailArray = dataShipmentDetail.Items
              let tempShipDetailsString = filterService.advancedSearch(tempShipDetailArray.map(obj => {
                  return { name: 'Id', type: 'int32', operation: 'Equals', value: obj.IdBookingEquipment }
              }))
              tempShipDetailsString = tempShipDetailsString.replaceAll('and', 'or').replace('&filter=', '')
              setFILTERVGM(tempShipDetailsString)
              moveEquipment()
              ctx.setIsLoad(false)
          })
      })    
    }

    const applyLinkedQuote = (quote) => {
      setLinkedQuoteId(quote.Id)

      extraValues.set("QuoteName", quote.Name)

      // Entity
      addValue("Company", quote.AccountCode, entitiesDict, setEntitiesDict)
      addValue("ClientCode", quote.AccountCode, entitiesDict, setEntitiesDict)
      addValue("ClientVAT", quote.AccountVATNumber, entitiesDict, setEntitiesDict)
      addValue("UserCompanyId", quote.UserCompanyId, extraValues, setExtraValues)
      addValue("Client Id", quote.AccountId, extraValues, setExtraValues)
      
      // Locations
      addValue("Original Port id", quote.OriginalPortId, extraValues, setExtraValues)
      addValue("Loading Port id", quote.LoadingPortId, extraValues, setExtraValues)
      addValue("Discharge Port id", quote.DischargePortId, extraValues, setExtraValues)
      addValue("Final Port id", quote.FinalPortId, extraValues, setExtraValues)

      addValue("Original Port", quote.OriginalPortName, locationsDict, setLocationsDict)
      addValue("Loading Port", quote.LoadingPortName, locationsDict, setLocationsDict)
      addValue("Discharge Port", quote.DischargePortName, locationsDict, setLocationsDict)
      addValue("Final Port", quote.FinalPortName, locationsDict, setLocationsDict)

      quoteGetService.getId(quote.Id).then((completeQuote) => {
        const newEquipItems = []
        const newShipmentIndexes = []
        let tempShipmentIndex = shipmentIndex
        let tempEquipmentIndex = EquipmentIndex
        let tempContainerIndex = containerIndex

        ;(completeQuote.Equipment ?? []).forEach((equipment) => {
          const qty = Number(equipment.Quantity) > 1 ? Number(equipment.Quantity) : 1
          for (let i = 0; i < qty; i++) {
            tempEquipmentIndex++
            newEquipItems.push({
              'EquipmentTypeId': equipment.EquipmentTypeId,
              'Equipment Type': `${equipment.EquipmentTypeLenght}${equipment.EquipmentTypeCode}`,
              'EquipmentType': equipment.EquipmentTypeCode,
              'Equipment Lenght': equipment.EquipmentTypeLenght,
              'Quantity': 1,
              'Cargo Description': '',
              'Load Weight (KG)': '',
              'Loading Date': '',
              'SOC': false,
              'IMO': false,
              'Reefer': false,
              'OpenTop': false,
              'RORO': false,
              'id': tempContainerIndex,
              'Shipment': tempShipmentIndex,
              'EquipmentIndex': tempEquipmentIndex,
            })
            newShipmentIndexes.push(tempShipmentIndex)
            tempShipmentIndex++
            tempContainerIndex++
          }
        })

        setShipmentObjArray(prev => [...prev, ...newEquipItems])
        setShipmentArray(prev => [...prev, ...newShipmentIndexes])
        setShipmentIndex(tempShipmentIndex)
        setContainerIndex(tempContainerIndex)
        setEquipmentIndex(tempEquipmentIndex)
      })
    }

    const setLinkedQuote = (quote) => {
      if (linkedQuoteId) {
        setPendingQuote(quote)
        setShowChangeQuoteModal(true)
      } else {
        applyLinkedQuote(quote)
      }
    }

    const confirmChangeQuote = () => {
      setShowChangeQuoteModal(false)
      applyLinkedQuote(pendingQuote)
      setPendingQuote(null)
    }

    const cancelChangeQuote = () => {
      setShowChangeQuoteModal(false)
      setPendingQuote(null)
    }

    const continueBooking = () => {
        setOpen(false)
    }
    
    const getLineBooking = (e) => {
        if (e.length) {
            sessionStorage.setItem('lines', JSON.stringify(e))
        } else {
            sessionStorage.removeItem('lines')
        }
    }

    const onSaveMove = () => {
      isMove = true
      openConfirmationModal()

      setConfirmMovement(false)
      setOpenEquipmentDrawer(false)
      ctx.setIsLoad(false)
    }

    const onMoveEquipment = (Id, moveEquipmentData) => {
        setConfirmMovement(false)
        const tempDetails = {
            "BookingId": bookingLine?.Id || '00000000-0000-0000-0000-000000000000',
            "NewBookingId": Id,
            "BookingEquipment": {
                'Id': moveEquipmentData.bookingEquipmentId || '00000000-0000-0000-0000-000000000000',
                'LoadingDate': moveEquipmentData["Loading Date"],
                'SOC': moveEquipmentData["SOC"] === true ? 'Y' : 'N',
                'Brand': moveEquipmentData["Brand"],
                'Model': moveEquipmentData["Model"],
                'Chassis': moveEquipmentData["Chassis"],
                'IdEquipment': moveEquipmentData["EquipmentId"] || '00000000-0000-0000-0000-000000000000',
                'IdEquipmentType': moveEquipmentData["EquipmentTypeId"] || '00000000-0000-0000-0000-000000000000',
                'IdEquipmentOwnerAccount': null,
                'GoodsDetails': moveEquipmentData["Cargo Description"],
                'TransportDetails': moveEquipmentData["Load Weight (KG)"],
            },
            "Dimensions": [],
        }

        if (moveEquipmentData.DimensionsHeight || moveEquipmentData.DimensionsWidth || moveEquipmentData.DimensionsLength) {
            tempDetails.Dimensions = [
                {
                    Id: moveEquipmentData.DimensionsId || '00000000-0000-0000-0000-000000000000',
                    BookingEquipmentId: moveEquipmentData.Id || '00000000-0000-0000-0000-000000000000',
                    DimensionsWidth: moveEquipmentData.DimensionsWidth || 0,
                    DimensionsHeight: moveEquipmentData.DimensionsHeight || 0,
                    DimensionsLength: moveEquipmentData.DimensionsLength || 0,
                }
            ]
        }
        if (moveEquipmentData.Front || moveEquipmentData.Back || moveEquipmentData.Left || moveEquipmentData.Right || moveEquipmentData.Height) {
            tempDetails.Dimensions = [
                {
                    Id: moveEquipmentData.DimensionsFROId || "00000000-0000-0000-0000-000000000000",
                    BookingEquipmentId: moveEquipmentData.Id || "00000000-0000-0000-0000-000000000000",
                    DimensionsCode: 'FRO',
                    DimensionsLength: moveEquipmentData.Front || 0,
                    DimensionsWidth: 0,
                    DimensionsHeight: 0,
                },
                {
                    Id: moveEquipmentData.DimensionsBACId || "00000000-0000-0000-0000-000000000000",
                    BookingEquipmentId: moveEquipmentData.Id || "00000000-0000-0000-0000-000000000000",
                    DimensionsCode: 'BAC',
                    DimensionsLength: moveEquipmentData.Back || 0,
                    DimensionsWidth: 0,
                    DimensionsHeight: 0,
                },
                {
                    Id: moveEquipmentData.DimensionsLEFId || "00000000-0000-0000-0000-000000000000",
                    BookingEquipmentId: moveEquipmentData.Id || "00000000-0000-0000-0000-000000000000",
                    DimensionsCode: 'LEF',
                    DimensionsLength: 0,
                    DimensionsWidth: moveEquipmentData.Left || 0,
                    DimensionsHeight: 0,
                },
                {
                    Id: moveEquipmentData.DimensionsRIGId || "00000000-0000-0000-0000-000000000000",
                    BookingEquipmentId: moveEquipmentData.Id || "00000000-0000-0000-0000-000000000000",
                    DimensionsCode: 'RIG',
                    DimensionsLength: 0,
                    DimensionsWidth: moveEquipmentData.Right || 0,
                    DimensionsHeight: 0,
                },
                {
                    Id: moveEquipmentData.DimensionsOVEId || "00000000-0000-0000-0000-000000000000",
                    BookingEquipmentId: moveEquipmentData.Id || "00000000-0000-0000-0000-000000000000",
                    DimensionsCode: 'OVE',
                    DimensionsLength: 0,
                    DimensionsWidth: 0,
                    DimensionsHeight: moveEquipmentData.Height || 0,
                },
            ]
        }

        return bookingEquipmentService.post(tempDetails).then(response => {
            ctx.setIsLoad(false)
            if (response.name === 'AxiosError') {
                ctx.toastMessages('error', '', response.response.data.Message || response.message)
                return
            }
            //(moveEquipmentData)
            //setOpen(true)
            ctx.toastMessages('success', '', t("EquipmentMoved"))

        })
    }

  return (
    <>
      {isLoaded ? (<LoadingBar />) : (
        <>
          <SimpleCreateBooking
            saveAs={saveAs}
            setSaveAs={setSaveAs}
            valueTimeline={valueTimeline}
            voyage={voyage}
            entities={entities}
            addShipment={addShipment}
            addBookingEquipments={addBookingEquipments}
            bookingEquipmentDict={bookingEquipmentDict}
            setBookingEquipmentDict={setBookingEquipmentDict}
            bookingEquipmentArray={bookingEquipmentArray}
            setBookingEquipmentArray={setBookingEquipmentArray}
            submitForApproval={submitForApproval}
            voyageDict={voyageDict}
            setVoyageDict={setVoyageDict}
            entitiesDict={entitiesDict}
            portsLocations={portsLocations}
            locationsDict={locationsDict}
            addValue={addValue}
            t={t}
            setEntitiesDict={setEntitiesDict}
            extraValues={extraValues}
            setExtraValues={setExtraValues}
            equipments={equipments}
            bookingEquipments={bookingEquipments}
            equipmentDict={equipmentDict}
            setEquipmentDict={setEquipmentDict}
            shipmentArray={shipmentArray}
            shipmentObjArray={shipmentObjArray}
            setShipmentObjArray={setShipmentObjArray}
            setShipmentArray={setShipmentArray}
            onFillFields={onFillFields}
            shipmentIndex={shipmentIndex}
            setShipmentIndex={setShipmentIndex}
            containerIndex={containerIndex}
            setContainerIndex={setContainerIndex}
            openDrawer={openDrawer}
            setOpenDrawer={setOpenDrawer}
            selectedLine={selectedLine}
            setSelectedLine={setSelectedLine}
            openConfirmModal={openConfirmModal}
            handleCloseConfirmModal={handleCloseConfirmModal}
            openConfirmationModal={openConfirmationModal}
            confirmationModal={confirmationModal}
            submitedApproval={submitedApproval}
            toJSONLocal={toJSONLocal}
            reformatDate={reformatDate}
            setDefaultBooking={setDefaultBooking}
            setLocationsDict={setLocationsDict}
            equipmentClass={equipmentClass}
            setEquipmentClass={setEquipmentClass}
            toastMessages={toastMessages}
            summary={summary}
            companies={companies}
            getAccountCompany={getAccountCompany}
            changedList={changedList}
            EquipmentIndex={EquipmentIndex}
            setEquipmentIndex={setEquipmentIndex}
            drawerName={drawerName}
            setDrawerName={setDrawerName}
            bookingLine={bookingLine}
            draft={draft}
            id={id}
            ctx={ctx}
            operation={operation}
            leavingPage={leavingPage}
            setLeavingPage={setLeavingPage}
            functionLeavingPage={functionLeavingPage}
            fieldsInDrawerEquipment={fieldsInDrawerEquipment}
            fieldsInDrawerShipment={fieldsInDrawerShipment}
            errorList={listErrors}
            isClient={isClient}
            moveEquipment={moveEquipment}
            open={open}
            openEquipmentDrawer={openEquipmentDrawer}
            setOpenEquipmentDrawer={setOpenEquipmentDrawer}
            FILTERVGM={FILTERVGM}
            openDrawerSplitShipments={openDrawerSplitShipments}
            setOpen={setOpen}
            continueBooking={continueBooking}
            getLineBooking={getLineBooking}
            onSaveMove={onSaveMove}
            confirmMovement={confirmMovement}
            setConfirmMovement={setConfirmMovement }
            entitiesVarNameDict={entitiesVarNameDict}
            setEntitiesVarNameDict={handleEntitiesFavoriteApply}
            portsVarNameDict={portsVarNameDict}
            setPortsVarNameDict={handlePortsFavoriteApply}
            setLinkedQuote={setLinkedQuote}
            shipmentChargesArray={shipmentChargesArray}
            showChangeQuoteModal={showChangeQuoteModal}
            confirmChangeQuote={confirmChangeQuote}
            cancelChangeQuote={cancelChangeQuote}
            isAdmin={isAdmin}
            onRefreshCharges={refreshShipmentCharges}
          />
          <div className='divForm'style={{ marginTop: '-6rem' }}>
            <M_Fieldset
              labelInside
              label={
                <span style={{ display: 'flex', alignItems: 'center' }}>
                  <i className="pi pi-box" style={{ marginRight: '10px' }} />
                  {t('AdditionalFields')}
                </span>
              }
              elements={
                <ExtensionForm
                  ref={extensionFormRef}
                  extendedEntityId="booking"
                  extendedItemId={operation === 'Edit' ? extraValues.get('id') : null}
                  canEdit={true}
                  handleErrorCallback={(error) => {
                    toastMessages(
                      'error',
                      '',
                      error?.response?.data?.message || error?.message || 'Extension error'
                    )
                  }}
                />
              }
            />
          </div>
        </>
      )
      }
    </>
  )
}